"use strict";
/**
 * This file is auto generated by `npm run generate-zod-schemas`.
 *
 * DO NOT EDIT THIS FILE MANUALLY.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupSchedulerSchemas = exports.endpointSchemas = exports.packageTemplateSchemas = exports.smartActionSchemas = exports.schemas = exports.requestBodySchemas = void 0;
const zod_1 = require("zod");
const PaginatedResponse = zod_1.z.object({
    first: zod_1.z.string().optional(),
    last: zod_1.z.string().optional(),
    prev: zod_1.z.string().optional(),
    next: zod_1.z.string().optional(),
    limit: zod_1.z.number().int(),
    count: zod_1.z.number().int(),
});
const NotificationMessages = zod_1.z.array(zod_1.z.unknown());
const GenericError = zod_1.z.object({ code: zod_1.z.number().int(), message: zod_1.z.string() });
const updateNotificationMessages_Body = zod_1.z.object({
    notificationMessages: NotificationMessages,
});
const GenericResponse = zod_1.z.object({ success: zod_1.z.boolean(), message: zod_1.z.string() });
const NotificationStatus = zod_1.z.enum(["read", "unread", "scheduled", "archived"]);
const updateAllNotificationMessages_Body = zod_1.z.object({
    status: NotificationStatus.optional(),
});
const PhoneVerificationRequest = zod_1.z.object({ phoneNumber: zod_1.z.string() });
const PhoneVerificationResponse = zod_1.z.object({ sessionId: zod_1.z.string() });
const OtpVerificationRequest = zod_1.z.object({
    code: zod_1.z.string(),
    sessionId: zod_1.z.string(),
});
const OtpVerificationResponse = zod_1.z.object({ success: zod_1.z.boolean() });
const ActivityLogEntries = zod_1.z.array(zod_1.z.unknown());
const ActivityAction = zod_1.z.enum([
    "create",
    "update",
    "overwrite",
    "delete",
    "read",
    "relate",
    "unrelate",
    "archive",
    "unarchive",
    "cancel",
    "reverse_cancel",
    "reschedule",
    "complete",
    "outcome_updated",
    "inactivate",
    "reactivate",
    "assign",
    "unassign",
    "pause",
    "resume",
    "approve",
    "unapprove",
    "intent",
    "sync-failed",
    "charged_payment",
    "email_sent",
    "sms_sent",
]);
const ActorType = zod_1.z.enum([
    "organization",
    "account",
    "client",
    "robot",
    "agent",
]);
const ResourceType = zod_1.z.enum([
    "account",
    "organization",
    "file",
    "folder",
    "client",
    "appointment",
    "scheduler",
    "availability",
    "invoice",
    "product",
    "package",
    "message",
    "smartaction",
    "note",
    "form",
    "billing-rate",
    "session-billing",
    "workflow",
    "subscription",
]);
const ActivityMessage = zod_1.z.object({
    action: ActivityAction,
    requestId: zod_1.z.string().optional(),
    actorId: zod_1.z.string(),
    actorType: ActorType,
    resourceId: zod_1.z.string(),
    resourceType: ResourceType,
    data: zod_1.z.object({}).partial().passthrough().optional(),
    organizationId: zod_1.z.string().optional(),
    clientId: zod_1.z.string().optional(),
});
const publishActivityMessage_Body = zod_1.z.object({
    activityMessage: ActivityMessage,
});
const generateContent_Body = zod_1.z
    .object({ organizationId: zod_1.z.string(), prompt: zod_1.z.string() })
    .passthrough();
const createApiKey_Body = zod_1.z.object({
    organizationId: zod_1.z.string(),
    accountId: zod_1.z.string(),
});
const ApiKey = zod_1.z.object({
    id: zod_1.z.string(),
    userId: zod_1.z.string(),
    accountId: zod_1.z.string().optional(),
    value: zod_1.z.string(),
    status: zod_1.z.enum(["active", "inactive", "deleted"]),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
});
const ApiKeys = zod_1.z.array(ApiKey);
const NotificationType = zod_1.z.enum(["system", "activity", "action"]);
const NotificationPreview = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
    imageUrl: zod_1.z.string().optional(),
    linkUrl: zod_1.z.string().optional(),
    updatedAt: zod_1.z.string().datetime({ offset: true }).optional(),
    createdAt: zod_1.z.string().datetime({ offset: true }).optional(),
    isDeleted: zod_1.z.boolean().optional(),
});
const NotificationMessage = zod_1.z.object({
    id: zod_1.z.string().optional(),
    subject: zod_1.z.string().optional(),
    body: zod_1.z.string().optional(),
    type: NotificationType,
    status: NotificationStatus.optional(),
    remindOn: zod_1.z.string().datetime({ offset: true }).optional(),
    updatedAt: zod_1.z.string().datetime({ offset: true }).optional(),
    createdAt: zod_1.z.string().datetime({ offset: true }).optional(),
    actor: zod_1.z
        .object({
        id: zod_1.z.string(),
        type: ActorType,
        preview: NotificationPreview.optional(),
    })
        .optional(),
    action: ActivityAction.optional(),
    resource: zod_1.z
        .object({
        id: zod_1.z.string(),
        type: ResourceType,
        preview: NotificationPreview.optional(),
    })
        .optional(),
});
const createNotificationMessage_Body = zod_1.z.object({
    requestId: zod_1.z.string().optional(),
    accountId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    notificationMessage: NotificationMessage,
});
const updateNotificationMessage_Body = zod_1.z.object({
    notificationMessage: NotificationMessage,
});
const SessionBillingCycle = zod_1.z.enum([
    "monthly",
    "weekly",
    "bi-weekly",
    "twice-per-month",
]);
const SessionBillingCountingRule = zod_1.z.enum(["all-sessions", "complete-only"]);
const AccountId = zod_1.z.string();
const OutcomeId = zod_1.z.string();
const SessionBillingOutcomeHistoryItem = zod_1.z.object({
    createdAt: zod_1.z.string().datetime({ offset: true }),
    memberId: AccountId,
    outcomeIds: zod_1.z.array(OutcomeId),
});
const SessionBillingBillableReviewer = zod_1.z.object({
    accountId: AccountId,
    addedBy: AccountId,
    addedAt: zod_1.z.string().datetime({ offset: true }),
});
const SessionBillingSettings = zod_1.z.object({
    currency: zod_1.z.string(),
    cycle: SessionBillingCycle,
    startDate: zod_1.z.string().datetime({ offset: true }),
    endDay: zod_1.z.number().optional(),
    timeZone: zod_1.z.string().optional(),
    countingRule: SessionBillingCountingRule,
    acceptedOutcomesHistory: zod_1.z.array(SessionBillingOutcomeHistoryItem).optional(),
    billableReviewers: zod_1.z.array(SessionBillingBillableReviewer).optional(),
});
const Organization = zod_1.z.object({
    id: zod_1.z.string(),
    email: zod_1.z.string(),
    slug: zod_1.z.string().optional(),
    createdAt: zod_1.z.string().datetime({ offset: true }).optional(),
    updatedAt: zod_1.z.string().datetime({ offset: true }).optional(),
    sessionBilling: SessionBillingSettings.optional(),
});
const Organizations = zod_1.z.array(Organization);
const createClient_Body = zod_1.z
    .object({
    email: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    company: zod_1.z.string().optional(),
    emails: zod_1.z.array(zod_1.z.string()).optional(),
    clientType: zod_1.z.string().optional(),
    phoneNumber: zod_1.z.string().optional(),
    assigneeId: zod_1.z.string().optional(),
    assignedBy: zod_1.z.string().optional(),
    organizationId: zod_1.z.string(),
    timeZone: zod_1.z.string().optional(),
    address: zod_1.z
        .object({
        name: zod_1.z.string().optional(),
        email: zod_1.z.string().optional(),
        city: zod_1.z.string(),
        country: zod_1.z.string(),
        line1: zod_1.z.string(),
        postalCode: zod_1.z.string(),
        state: zod_1.z.string(),
    })
        .optional(),
    customFields: zod_1.z
        .array(zod_1.z.object({
        field: zod_1.z.string(),
        value: zod_1.z.union([
            zod_1.z.string(),
            zod_1.z.number(),
            zod_1.z.boolean(),
            zod_1.z.array(zod_1.z.string()),
        ]),
    }))
        .optional(),
    statusId: zod_1.z.string().nullish(),
})
    .passthrough();
const indexAppointment_Body = zod_1.z
    .object({ id: zod_1.z.string(), organizationId: zod_1.z.string() })
    .passthrough();
const DashboardConfiguration = zod_1.z.object({
    name: zod_1.z.string(),
    source: zod_1.z.enum(["appointment_metrics", "package_instance_state"]),
    granularity: zod_1.z.enum(["1 day", "1 week"]),
    rangeStart: zod_1.z.string(),
    rangeEnd: zod_1.z.string(),
    series: zod_1.z.array(zod_1.z.object({
        name: zod_1.z.string(),
        type: zod_1.z.enum(["counts", "cumulative_counts"]),
        visualType: zod_1.z.enum(["line", "bar"]),
        color: zod_1.z.string(),
        filters: zod_1.z
            .object({ schedulerId: zod_1.z.string(), outcomeId: zod_1.z.string() })
            .partial()
            .optional(),
    })),
});
const generateTimeseriesCounts_Body = zod_1.z.object({
    source: zod_1.z.enum(["appointment_metrics", "package_instance_state"]),
    rangeStart: zod_1.z.string().optional(),
    rangeEnd: zod_1.z.string().optional(),
    schedulerId: zod_1.z.string().optional(),
    outcomeId: zod_1.z.string().optional(),
    memberId: zod_1.z.string().optional(),
    packageId: zod_1.z.string().optional(),
    clientId: zod_1.z.string().optional(),
    labelIds: zod_1.z.array(zod_1.z.string()).optional(),
});
const search_Body = zod_1.z
    .object({
    organizationId: zod_1.z.string(),
    collection: zod_1.z.enum([
        "accounts",
        "appointments",
        "contacts",
        "invoices",
        "packageInstances",
    ]),
    query: zod_1.z.string().optional(),
    queryBy: zod_1.z.array(zod_1.z.string()).optional(),
    filterBy: zod_1.z
        .array(zod_1.z.union([
        zod_1.z
            .object({
            field: zod_1.z.string(),
            operator: zod_1.z
                .enum(["eq", "ne", "gt", "gte", "lt", "lte"])
                .optional(),
            value: zod_1.z.string(),
            refCollection: zod_1.z.string().optional(),
        })
            .passthrough(),
        zod_1.z
            .object({
            field: zod_1.z.string(),
            value: zod_1.z.array(zod_1.z.string()),
            refCollection: zod_1.z.string().optional(),
        })
            .passthrough(),
    ]))
        .optional(),
    sortBy: zod_1.z
        .array(zod_1.z
        .object({
        field: zod_1.z.string(),
        direction: zod_1.z.enum(["asc", "desc"]),
        refCollection: zod_1.z.string().optional(),
    })
        .passthrough())
        .optional(),
    includeFields: zod_1.z
        .array(zod_1.z
        .object({ fields: zod_1.z.array(zod_1.z.string()), refCollection: zod_1.z.string() })
        .passthrough())
        .optional(),
    limit: zod_1.z.number().int().gte(1).lte(100).optional(),
    offset: zod_1.z.number().int().gte(0).optional(),
})
    .passthrough();
const SignupRequest = zod_1.z.object({
    email: zod_1.z.string().email(),
    password: zod_1.z.string().min(8).max(128),
});
const SignupResponse = zod_1.z.object({
    accountId: zod_1.z.string(),
    email: zod_1.z.string().email(),
});
const skipIntegrations = zod_1.z.union([zod_1.z.boolean(), zod_1.z.string()]).nullish();
const BaseIntegration = zod_1.z
    .object({
    memberId: zod_1.z.string(),
    email: zod_1.z.string(),
    integrationId: zod_1.z.string().optional(),
})
    .passthrough();
const IntegrationProvider = zod_1.z
    .object({ provider: zod_1.z.enum(["google", "microsoft"]) })
    .passthrough();
const IntegrationCalendar = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    canEdit: zod_1.z.boolean(),
    isDefaultCalendar: zod_1.z.boolean(),
    onlineMeetingProviders: zod_1.z.array(zod_1.z.string()).optional(),
    vendorData: zod_1.z.object({}).partial().passthrough().optional(),
    integration: BaseIntegration.and(IntegrationProvider),
})
    .passthrough();
const CalendarIntegration = BaseIntegration.and(IntegrationProvider).and(zod_1.z.object({ calendars: zod_1.z.array(IntegrationCalendar) }).passthrough());
const BaseIntegrationArray = zod_1.z.array(BaseIntegration);
const Integrations = zod_1.z
    .object({
    calendars: zod_1.z.array(CalendarIntegration),
    emails: BaseIntegrationArray,
    zoom: BaseIntegrationArray,
})
    .passthrough();
const type = zod_1.z.enum(["session", "billable"]);
const setupSessionBilling_Body = zod_1.z.object({
    currency: zod_1.z.string(),
    cycle: SessionBillingCycle,
    countingRule: SessionBillingCountingRule,
    startDate: zod_1.z.string(),
    endDay: zod_1.z.number().optional(),
    timeZone: zod_1.z.string(),
    acceptedOutcomes: zod_1.z.array(OutcomeId),
    billingRates: zod_1.z.array(zod_1.z
        .object({
        title: zod_1.z.string(),
        value: zod_1.z.number(),
        type: type,
        icon: zod_1.z.string().optional(),
    })
        .passthrough()),
});
const BillingRateStatus = zod_1.z.enum(["active", "inactive"]);
const BillingRate = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    value: zod_1.z.number(),
    type: zod_1.z.enum(["session", "billable"]),
    icon: zod_1.z.string().optional(),
    status: BillingRateStatus.optional(),
    overwriting: zod_1.z
        .record(zod_1.z.object({ value: zod_1.z.number() }).partial().passthrough())
        .optional(),
});
const updateSessionBillingAcceptedOutcomes_Body = zod_1.z
    .object({ acceptedOutcomes: zod_1.z.array(OutcomeId) })
    .partial();
const updateBillableReviewers_Body = zod_1.z.object({
    billableReviewerIds: zod_1.z.array(zod_1.z.string()),
});
const BillingTransactionArtifactKind = zod_1.z.enum([
    "appointment",
    "billableRequest",
]);
const BillingTransactionFulfillment = zod_1.z.enum([
    "scheduled",
    "rescheduled",
    "canceled",
    "completed",
    "no-show",
    "non-billable",
]);
const BillingTransaction = zod_1.z.object({
    memberId: zod_1.z.string(),
    clientId: zod_1.z.string(),
    artifact: zod_1.z.object({
        kind: BillingTransactionArtifactKind,
        id: zod_1.z.string(),
        title: zod_1.z.string(),
        packageInstanceId: zod_1.z.string().optional(),
    }),
    date: zod_1.z.string().datetime({ offset: true }).optional(),
    paidAt: zod_1.z.string().datetime({ offset: true }).optional(),
    amount: zod_1.z.number().optional(),
    rate: zod_1.z.object({ id: zod_1.z.string(), value: zod_1.z.number() }),
    fulfillment: BillingTransactionFulfillment,
});
const ClientSessions = zod_1.z.object({
    client: zod_1.z.object({
        id: zod_1.z.string(),
        firstName: zod_1.z.string().optional(),
        lastName: zod_1.z.string().optional(),
        email: zod_1.z.string().optional(),
        status: zod_1.z.string().optional(),
        color: zod_1.z
            .object({ background: zod_1.z.string(), foreground: zod_1.z.string() })
            .optional(),
        avatarURL: zod_1.z.string().optional(),
    }),
    parent: zod_1.z
        .object({
        id: zod_1.z.string(),
        firstName: zod_1.z.string().optional(),
        lastName: zod_1.z.string().optional(),
        email: zod_1.z.string().optional(),
        status: zod_1.z.string().optional(),
        clientType: zod_1.z.string(),
        color: zod_1.z
            .object({ background: zod_1.z.string(), foreground: zod_1.z.string() })
            .optional(),
        avatarURL: zod_1.z.string().optional(),
    })
        .optional(),
    packages: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        title: zod_1.z.string(),
        sessionsGroupedByRate: zod_1.z.array(zod_1.z.object({
            quantity: zod_1.z.number(),
            rate: zod_1.z.number(),
            title: zod_1.z.string(),
            amount: zod_1.z.number(),
            isRateCurrentValue: zod_1.z.boolean().optional(),
            transactions: zod_1.z.array(BillingTransaction).optional(),
        })),
    })),
});
const markBillingTransactionsAsPaidOrUnpaid_Body = zod_1.z.object({
    start: zod_1.z.string().optional(),
    end: zod_1.z.string().optional(),
    memberId: zod_1.z.string(),
    action: zod_1.z.enum(["pay", "unpay"]),
});
const addBillingRate_Body = zod_1.z.object({
    title: zod_1.z.string(),
    value: zod_1.z.number(),
    icon: zod_1.z.string().optional(),
    type: type,
});
const updateBillingRate_Body = zod_1.z
    .object({ title: zod_1.z.string(), value: zod_1.z.number(), icon: zod_1.z.string() })
    .partial();
const updateBillingRateStatus_Body = zod_1.z
    .object({ status: BillingRateStatus })
    .partial();
const overwriteBillingRate_Body = zod_1.z
    .object({ memberId: zod_1.z.string(), value: zod_1.z.number() })
    .partial();
const submitBillableRequest_Body = zod_1.z.object({
    billingRateId: zod_1.z.string(),
    date: zod_1.z.string(),
    clientId: zod_1.z.string().optional(),
    duration: zod_1.z.number(),
    description: zod_1.z.string().optional(),
});
const BillableRequestStatus = zod_1.z.enum(["submitted", "rejected", "approved"]);
const BillableRequestHistoryEntry = zod_1.z.object({
    accountId: zod_1.z.string(),
    status: BillableRequestStatus,
    reason: zod_1.z.string().optional(),
    date: zod_1.z.string().datetime({ offset: true }),
});
const BillableRequest = zod_1.z.object({
    id: zod_1.z.string(),
    billingRate: zod_1.z.unknown(),
    accountId: zod_1.z.string(),
    date: zod_1.z.string(),
    dateCreated: zod_1.z.string().optional(),
    dateUpdated: zod_1.z.string().optional(),
    status: BillableRequestStatus,
    statusHistory: zod_1.z.array(BillableRequestHistoryEntry),
    clientId: zod_1.z.string().optional(),
    duration: zod_1.z.number(),
    description: zod_1.z.string().optional(),
    paidAt: zod_1.z.string().optional(),
});
const changeBillableRequestStatus_Body = zod_1.z.object({
    status: BillableRequestStatus,
});
const BillableRequestClient = zod_1.z.object({
    firstName: zod_1.z.string().optional(),
    lastName: zod_1.z.string().optional(),
    email: zod_1.z.string(),
    id: zod_1.z.string(),
});
const TodaysView = zod_1.z.object({
    total: zod_1.z.number(),
    metricPoint: zod_1.z.number().optional(),
    metricChange: zod_1.z.number().optional(),
    metricIsPercentage: zod_1.z.boolean().optional(),
    metricIsPositive: zod_1.z.boolean().optional(),
});
const updateClient_Body = zod_1.z
    .object({
    email: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    company: zod_1.z.string(),
    emails: zod_1.z.array(zod_1.z.string()),
    clientType: zod_1.z.string(),
    phoneNumber: zod_1.z.string(),
    assigneeId: zod_1.z.string(),
    assignedBy: zod_1.z.string(),
    timeZone: zod_1.z.string(),
    address: zod_1.z.object({
        name: zod_1.z.string().optional(),
        email: zod_1.z.string().optional(),
        city: zod_1.z.string(),
        country: zod_1.z.string(),
        line1: zod_1.z.string(),
        postalCode: zod_1.z.string(),
        state: zod_1.z.string(),
    }),
    customFields: zod_1.z.array(zod_1.z.object({
        field: zod_1.z.string(),
        value: zod_1.z.union([
            zod_1.z.string(),
            zod_1.z.number(),
            zod_1.z.boolean(),
            zod_1.z.array(zod_1.z.string()),
        ]),
    })),
    statusId: zod_1.z.string().nullable(),
})
    .partial()
    .passthrough();
const UsagePricing = zod_1.z
    .object({ amount: zod_1.z.number(), currency: zod_1.z.string(), taxTypeId: zod_1.z.string() })
    .passthrough();
const PackageFrequencyType = zod_1.z.enum(["months", "weeks", "years"]);
const SuggestedFrequency = zod_1.z
    .object({ total: zod_1.z.number(), type: PackageFrequencyType })
    .passthrough();
const PackageInstanceItem = zod_1.z
    .object({
    productId: zod_1.z.string().optional(),
    schedulerId: zod_1.z.string(),
    quantity: zod_1.z.number(),
    curriculum: zod_1.z.boolean().optional(),
    usagePricing: UsagePricing.optional(),
    suggestedFrequency: SuggestedFrequency.optional(),
    billingRate: BillingRate.optional(),
    isUnlimited: zod_1.z.boolean().optional(),
    memberIds: zod_1.z.array(zod_1.z.string()).optional(),
})
    .passthrough();
const PackageInstancePaymentStatus = zod_1.z.enum([
    "paid",
    "failed",
    "scheduled",
    "shared",
    "cancelled",
]);
const PackageInstancePayment = zod_1.z
    .object({
    invoiceId: zod_1.z.string(),
    dueDate: zod_1.z.string().datetime({ offset: true }),
    paidAt: zod_1.z.string().datetime({ offset: true }).optional(),
    title: zod_1.z.string(),
    status: PackageInstancePaymentStatus,
    currency: zod_1.z.string(),
    amount: zod_1.z.number(),
    paymentIntentId: zod_1.z.string().optional(),
})
    .passthrough();
const UsagePackageInvoiceCutOffDate = zod_1.z.enum([
    "first-of-month",
    "last-of-month",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
]);
const UsagePackageInvoicing = zod_1.z
    .object({
    method: zod_1.z.enum(["auto", "manual", "subscription"]),
    period: zod_1.z.enum(["months", "weeks"]),
    autoChargeDay: zod_1.z.number().optional(),
    cutOffDate: UsagePackageInvoiceCutOffDate.optional(),
    dueAfterDays: zod_1.z.number().optional(),
    subscriptionAmount: zod_1.z.number().optional(),
})
    .passthrough();
const OnTrackStatus = zod_1.z.enum([
    "onTrack",
    "offTrack",
    "atRisk",
    "paused",
    "completed",
    "disabled",
]);
const OnTrackHistory = zod_1.z
    .object({
    action: zod_1.z.enum(["sentNotification", "updatedStatus"]),
    status: OnTrackStatus,
    date: zod_1.z.string().datetime({ offset: true }),
    smartActionId: zod_1.z.string().optional(),
})
    .passthrough();
const OnTrackRules = zod_1.z
    .object({
    allowClientView: zod_1.z.boolean(),
    atRiskSessionCount: zod_1.z.number().nullable(),
    offTrackSessionCount: zod_1.z.number(),
    onTrackDaysInterval: zod_1.z.number(),
})
    .passthrough();
const OnTrackNotification = zod_1.z
    .object({
    afterDays: zod_1.z.number(),
    clientMessage: zod_1.z.string().optional(),
    sendToClient: zod_1.z.boolean(),
    sendToMember: zod_1.z.boolean(),
})
    .passthrough();
const OnTrackNotifications = zod_1.z
    .object({
    atRisk: zod_1.z.array(OnTrackNotification).nullable(),
    offTrack: zod_1.z.array(OnTrackNotification).nullable(),
})
    .partial()
    .passthrough();
const PackageInstanceCard = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    internalName: zod_1.z.string().optional(),
    icon: zod_1.z.string().optional(),
    status: zod_1.z.enum([
        "active",
        "completed",
        "scheduled",
        "deleted",
        "paused",
        "ordered",
        "processing",
        "blocked",
    ]),
    totalBooked: zod_1.z.number(),
    totalAccrued: zod_1.z.number().nullable(),
    totalAvailable: zod_1.z.number().nullable(),
    totalCompleted: zod_1.z.number(),
    totalBookedFromUnlimitedSchedulers: zod_1.z.number(),
    contentType: zod_1.z.enum(["sessions", "time"]).optional(),
    timeType: zod_1.z.enum(["minutes", "hours"]).optional(),
    packageType: zod_1.z
        .enum(["one-time", "recurring", "usage", "flexible", "subscription"])
        .optional(),
    frequency: zod_1.z.enum(["months", "weeks", "years"]).optional(),
    cycles: zod_1.z
        .array(zod_1.z
        .object({
        start: zod_1.z.string().datetime({ offset: true }),
        end: zod_1.z.string().datetime({ offset: true }),
        title: zod_1.z.string(),
        isFull: zod_1.z.boolean().optional(),
        isCurrent: zod_1.z.boolean().optional(),
        isFuture: zod_1.z.boolean(),
        totalBooked: zod_1.z.number(),
        totalAvailable: zod_1.z.number(),
        totalCompleted: zod_1.z.number(),
        totalBookedFromUnlimitedSchedulers: zod_1.z.number(),
        frequency: zod_1.z.number(),
        pausedOn: zod_1.z.string().datetime({ offset: true }).optional(),
        resumedOn: zod_1.z.string().datetime({ offset: true }).optional(),
    })
        .passthrough())
        .optional(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    endDate: zod_1.z.string().datetime({ offset: true }).optional(),
    startDate: zod_1.z.string().datetime({ offset: true }).optional(),
    resetDate: zod_1.z.string().datetime({ offset: true }).optional(),
    pausedOn: zod_1.z.string().datetime({ offset: true }).optional(),
    isRollover: zod_1.z.boolean().optional(),
    distributeSessions: zod_1.z.boolean().optional(),
    items: zod_1.z.array(PackageInstanceItem),
    participants: zod_1.z.array(zod_1.z.string()).optional(),
    supervisors: zod_1.z.array(zod_1.z.string()).optional(),
    packageId: zod_1.z.string(),
    clientId: zod_1.z.string(),
    isLocked: zod_1.z.boolean().optional(),
    invoiceId: zod_1.z.string().optional(),
    payments: zod_1.z.array(PackageInstancePayment).optional(),
    usageInvoicing: UsagePackageInvoicing.optional(),
    onTrackStatus: OnTrackStatus.optional(),
    onTrackHistory: zod_1.z.array(OnTrackHistory).optional(),
    onTrackRules: OnTrackRules.nullish(),
    onTrackNotifications: OnTrackNotifications.nullish(),
    onTrackEnabled: zod_1.z.boolean().optional(),
    organizationSettings: zod_1.z
        .object({ hideNotesAndFormsFromManagers: zod_1.z.boolean() })
        .partial()
        .passthrough()
        .optional(),
    tierTitle: zod_1.z.string().optional(),
    tierPriceTitle: zod_1.z.string().optional(),
    expiration: zod_1.z.string().datetime({ offset: true }).nullish(),
    subscriptionCancelDate: zod_1.z.string().datetime({ offset: true }).optional(),
})
    .passthrough();
const PackageInstanceItemPublic = zod_1.z
    .object({
    productId: zod_1.z.string().optional(),
    schedulerId: zod_1.z.string(),
    quantity: zod_1.z.number(),
    curriculum: zod_1.z.boolean().optional(),
    isUnlimited: zod_1.z.boolean().optional(),
    usagePricing: zod_1.z
        .object({
        amount: zod_1.z.number(),
        currency: zod_1.z.string(),
        taxTypeId: zod_1.z.string(),
    })
        .passthrough()
        .optional(),
    suggestedFrequency: SuggestedFrequency.optional(),
    memberIds: zod_1.z.array(zod_1.z.string()).optional(),
})
    .passthrough();
const PackageInstancePublic = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    icon: zod_1.z.string().optional(),
    status: zod_1.z.enum([
        "active",
        "completed",
        "scheduled",
        "deleted",
        "paused",
        "ordered",
        "processing",
        "blocked",
    ]),
    totalBooked: zod_1.z.number(),
    totalAccrued: zod_1.z.number().nullable(),
    totalAvailable: zod_1.z.number().nullable(),
    totalCompleted: zod_1.z.number(),
    totalBookedFromUnlimitedSchedulers: zod_1.z.number(),
    contentType: zod_1.z.enum(["sessions", "time"]).optional(),
    timeType: zod_1.z.enum(["minutes", "hours"]).optional(),
    packageType: zod_1.z
        .enum(["one-time", "recurring", "usage", "flexible", "subscription"])
        .optional(),
    frequency: zod_1.z.enum(["months", "weeks", "years"]).optional(),
    cycles: zod_1.z
        .array(zod_1.z
        .object({
        start: zod_1.z.string().datetime({ offset: true }),
        end: zod_1.z.string().datetime({ offset: true }),
        title: zod_1.z.string(),
        isFull: zod_1.z.boolean().optional(),
        isCurrent: zod_1.z.boolean().optional(),
        isFuture: zod_1.z.boolean(),
        totalBooked: zod_1.z.number(),
        totalAvailable: zod_1.z.number(),
        totalCompleted: zod_1.z.number(),
        totalBookedFromUnlimitedSchedulers: zod_1.z.number(),
        frequency: zod_1.z.number(),
    })
        .passthrough())
        .optional(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    endDate: zod_1.z.string().datetime({ offset: true }).optional(),
    startDate: zod_1.z.string().datetime({ offset: true }).optional(),
    resetDate: zod_1.z.string().datetime({ offset: true }).optional(),
    pausedOn: zod_1.z.string().datetime({ offset: true }).optional(),
    isRollover: zod_1.z.boolean().optional(),
    distributeSessions: zod_1.z.boolean().optional(),
    items: zod_1.z.array(PackageInstanceItemPublic),
    participants: zod_1.z.array(zod_1.z.string()).optional(),
    supervisors: zod_1.z.array(zod_1.z.string()).optional(),
    packageId: zod_1.z.string(),
    clientId: zod_1.z.string(),
    isLocked: zod_1.z.boolean().optional(),
    payments: zod_1.z.array(PackageInstancePayment).optional(),
    onTrackStatus: OnTrackStatus.optional(),
    onTrackHistory: zod_1.z.array(OnTrackHistory).optional(),
    onTrackRules: OnTrackRules.nullish(),
    tierTitle: zod_1.z.string().optional(),
    tierPriceTitle: zod_1.z.string().optional(),
    setupIntentId: zod_1.z.string().optional(),
    isFree: zod_1.z.boolean().optional(),
    subscriptionCancelDate: zod_1.z.string().datetime({ offset: true }).optional(),
})
    .passthrough();
const UpdatePackageDurationItemsRequestBody = zod_1.z.object({
    items: zod_1.z.array(PackageInstanceItem),
});
const UpdatePackageDurationRequestBody = zod_1.z.object({
    total: zod_1.z.number(),
    applyRecurring: zod_1.z.boolean(),
});
const updatePackageInstanceDuration_Body = zod_1.z.union([
    UpdatePackageDurationItemsRequestBody,
    UpdatePackageDurationRequestBody,
]);
const updatePackageInstancePaymentOption_Body = zod_1.z.object({
    paymentOptionIndex: zod_1.z.number(),
    couponId: zod_1.z.string().optional(),
});
const PackageInstanceOrganizationSettings = zod_1.z
    .object({ hideNotesAndFormsFromManagers: zod_1.z.boolean() })
    .partial()
    .passthrough();
const updatePackageInstanceDetails_Body = zod_1.z
    .object({
    clientId: zod_1.z.string(),
    title: zod_1.z.string(),
    icon: zod_1.z.string(),
    locked: zod_1.z.boolean(),
    participants: zod_1.z.array(zod_1.z.string()),
    supervisors: zod_1.z.array(zod_1.z.string()),
    organizationSettings: PackageInstanceOrganizationSettings,
    billingRates: zod_1.z.array(zod_1.z.object({ schedulerId: zod_1.z.string(), value: zod_1.z.number() }).passthrough()),
    members: zod_1.z.array(zod_1.z
        .object({ schedulerId: zod_1.z.string(), memberIds: zod_1.z.array(zod_1.z.string()) })
        .passthrough()),
    curriculumAssignments: zod_1.z.array(zod_1.z
        .object({ schedulerId: zod_1.z.string(), participantId: zod_1.z.string() })
        .passthrough()),
    onTrackRules: OnTrackRules.nullable(),
    onTrackNotifications: OnTrackNotifications.nullable(),
    onTrackEnabled: zod_1.z.boolean(),
    onTrackStatus: OnTrackStatus,
})
    .partial();
const createPackageOrder_Body = zod_1.z.object({
    setupIntentClientSecret: zod_1.z.string(),
    paymentOptionIndex: zod_1.z.number(),
    packageTemplateId: zod_1.z.string(),
    quantity: zod_1.z.number().optional(),
});
const updateUsagePricing_Body = zod_1.z.object({
    usagePricingList: zod_1.z.array(zod_1.z.object({
        amount: zod_1.z.number(),
        currency: zod_1.z.string(),
        taxTypeId: zod_1.z.string(),
        schedulerId: zod_1.z.string(),
    })),
});
const InvoiceStatus = zod_1.z.enum([
    "shared",
    "failed",
    "paid",
    "scheduled",
    "refunded",
    "partially_refunded",
    "open",
    "draft",
    "viewed",
    "void",
    "deleted",
    "processing",
    "cancelled",
]);
const InvoiceFrequency = zod_1.z.object({
    interval: zod_1.z.string(),
    intervalCount: zod_1.z.number().optional(),
    paymentCount: zod_1.z.number().optional(),
});
const InvoiceCustomField = zod_1.z.object({ title: zod_1.z.string(), value: zod_1.z.string() });
const InvoiceItem = zod_1.z.object({
    productId: zod_1.z.string().optional(),
    description: zod_1.z.string(),
    quantity: zod_1.z.number(),
    unitAmount: zod_1.z.number(),
    itemAmount: zod_1.z.number(),
    taxTypeId: zod_1.z.string(),
    taxAmount: zod_1.z.number(),
    taxInclusive: zod_1.z.boolean(),
    transactionId: zod_1.z.string().optional(),
    addedAt: zod_1.z.string().optional(),
});
const SmartActionTemplateActionType = zod_1.z.enum([
    "add-label",
    "send-form",
    "send-form-with-signed-contract",
    "show-form",
    "send-reminder",
    "send-library-item",
    "send-invoice",
    "bill-scheduled-invoice",
    "send-bill-invoice-notification",
    "send-invoice-reminder-coach",
    "send-invoice-reminder-client",
    "send-trial-will-end-reminder",
    "todo-assignment-reminder",
    "todo-due-date-reminder",
    "todo-week-reminder",
    "recurring-package-instance",
    "complete-package-instance",
    "create-billable-request",
    "rollover-pending-transactions",
    "add-billing-transaction-to-ap-invoice",
    "add-billing-transaction-to-ubp-invoice",
    "recompute-billing-transaction",
    "collect-package-payment",
    "send-form-reminder",
    "send-package-tracking-notification",
    "check-package-tracking-status",
    "sync-invoice",
    "sync-subscription",
    "create-package-instance-subscription",
    "expire-package-instance",
    "call-endpoint",
    "activate-package-instance",
    "sync-invoice-with-quick-books",
    "update-package-instance-tier",
]);
const SmartActionTemplateActionArtifactType = zod_1.z.enum([
    "labels",
    "forms",
    "files",
    "folders",
    "links",
    "invoices",
    "packages",
    "packageInstances",
    "subscriptions",
    "accounts",
    "clients",
    "appointments",
    "stripe-subscriptions",
    "stripe-products",
]);
const SmartActionTemplateActionMethod = zod_1.z.enum([
    "to-client-record",
    "via-email",
    "during-book-flow",
    "via-sms",
    "via-email-via-sms",
    "via-sms-via-email",
]);
const SmartActionTemplateActionSettings = zod_1.z
    .object({
    billingRateId: zod_1.z.string(),
    duration: zod_1.z.number(),
    adminOnly: zod_1.z.boolean().nullable(),
    allowCreate: zod_1.z.boolean(),
    priceId: zod_1.z.string(),
})
    .partial();
const SmartActionTemplateAction = zod_1.z.object({
    type: SmartActionTemplateActionType,
    artifactType: SmartActionTemplateActionArtifactType.optional(),
    resourceId: zod_1.z.string().nullish(),
    method: SmartActionTemplateActionMethod.optional(),
    settings: SmartActionTemplateActionSettings.optional(),
});
const SmartActionEventTimming = zod_1.z.enum([
    "immediately",
    "before",
    "after",
    "onDate",
    "count",
]);
const SmartActionEventTrigger = zod_1.z.enum([
    "appointment-is-booked",
    "appointment-starts",
    "appointment-ends",
    "appointment-outcome-updated",
    "form-is-submitted",
    "send-form-reminder",
    "payment-is-completed",
    "package-is-booked",
    "package-is-assigned",
    "package-sessions-completed",
    "product-is-purchased",
    "invoice-send-date",
    "package-instance-is-created",
    "package-instance-recurring-due",
    "package-instance-ended",
    "event-is-booked",
    "event-starts",
    "event-ends",
    "invoice-is-due",
    "subscription-trial-will-end",
    "todo-assignment",
    "todo-due-date",
    "billing-transaction-computed",
    "package-tracking-status-changed",
    "package-is-at-risk",
    "package-is-off-track",
    "invoice-updated-on-stripe",
    "subscription-updated-on-stripe",
    "product-updated-on-stripe",
    "price-updated-on-stripe",
    "package-template-created",
    "package-template-updated",
    "package-instance-payment-collected",
    "none",
    "invoice-paid",
    "setup-intent-requires-action",
    "payment-intent-processing",
    "package-instance-updated",
    "package-instance-subscription-updated",
]);
const SmartActionEventType = zod_1.z.enum([
    "appointment",
    "form",
    "package",
    "invoice",
    "packageInstance",
    "subscriptions",
    "todo",
    "stripe-products",
    "stripe-prices",
    "stripe-subscriptions",
]);
const SmartActionEventSettings = zod_1.z
    .object({
    acceptedOutcomes: zod_1.z.array(zod_1.z.string()),
    appointmentCount: zod_1.z.number(),
})
    .partial();
const SmartActionTemplateEventWhen = zod_1.z.object({
    value: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]),
    type: zod_1.z.enum(["hours", "days"]),
});
const SmartActionTemplateEvent = zod_1.z.object({
    timming: SmartActionEventTimming,
    trigger: SmartActionEventTrigger,
    resourceId: zod_1.z.string().nullish(),
    type: SmartActionEventType.optional(),
    settings: SmartActionEventSettings.optional(),
    when: SmartActionTemplateEventWhen.optional(),
    customType: zod_1.z.string().nullish(),
});
const SmartActionTemplate = zod_1.z.object({
    action: SmartActionTemplateAction,
    event: SmartActionTemplateEvent,
});
const InvoiceMethod = zod_1.z.enum(["manual", "auto"]);
const InvoiceKind = zod_1.z.enum([
    "usage-based",
    "accounts-payable",
    "package-payment",
]);
const InvoiceCredit = zod_1.z.object({
    description: zod_1.z.string(),
    amount: zod_1.z.number(),
    addedAt: zod_1.z.string().datetime({ offset: true }),
    paymentIntentId: zod_1.z.string().optional(),
    refundId: zod_1.z.string().optional(),
    type: zod_1.z.enum(["subscription", "initial-deposit"]).optional(),
});
const Invoice = zod_1.z.object({
    id: zod_1.z.string(),
    payeeId: zod_1.z.string(),
    contactId: zod_1.z.string(),
    couponId: zod_1.z.string().optional(),
    status: InvoiceStatus,
    dueDate: zod_1.z.string().optional(),
    cutoffDate: zod_1.z.string().optional(),
    dueAfterDays: zod_1.z.number().optional(),
    currency: zod_1.z.string(),
    amount: zod_1.z.number(),
    tax: zod_1.z.number().optional(),
    discount: zod_1.z.number().optional(),
    total: zod_1.z.number(),
    recurring: InvoiceFrequency.optional(),
    subscriptionId: zod_1.z.string().optional(),
    memo: zod_1.z.string().optional(),
    footer: zod_1.z.string().optional(),
    customFields: zod_1.z.array(InvoiceCustomField).optional(),
    items: zod_1.z.array(InvoiceItem).optional(),
    stripe: zod_1.z.object({ customer: zod_1.z.unknown() }).partial().optional(),
    invoice: zod_1.z.unknown(),
    subscription: zod_1.z.string().optional(),
    scheduledSmartActions: zod_1.z.array(zod_1.z.string()).optional(),
    sendAt: zod_1.z.string().optional(),
    smartActionTemplates: zod_1.z.array(SmartActionTemplate).optional(),
    isUpcomingInvoice: zod_1.z.boolean().optional(),
    wasScheduled: zod_1.z.boolean().optional(),
    paymentMethod: zod_1.z.string().optional(),
    paidAt: zod_1.z.string().optional(),
    productId: zod_1.z.string().optional(),
    approval: zod_1.z
        .object({ approvedAt: zod_1.z.string(), approvedBy: zod_1.z.string() })
        .nullish(),
    paymentIntentId: zod_1.z.string().optional(),
    invoiceMethod: InvoiceMethod.optional(),
    packageInstanceId: zod_1.z.string().nullish(),
    pendingTransactions: zod_1.z.array(zod_1.z.string()).optional(),
    memberId: zod_1.z.string().optional(),
    kind: InvoiceKind.optional(),
    credits: zod_1.z.array(InvoiceCredit).optional(),
    minimumAmount: zod_1.z.number().optional(),
    paymentNeedsAttention: zod_1.z.boolean().optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
const assignPackage_Body = zod_1.z.object({
    packageId: zod_1.z.string(),
    isAssignedByCoach: zod_1.z.boolean().optional(),
    startDate: zod_1.z.string().optional(),
    expiration: zod_1.z.string().nullish(),
    quantity: zod_1.z.number().optional(),
    customSubscriptionId: zod_1.z.string().optional(),
    locked: zod_1.z.boolean().optional(),
    title: zod_1.z.string().optional(),
    icon: zod_1.z.string().optional(),
    paymentOptionIndex: zod_1.z.number().optional(),
    invoiceOption: zod_1.z
        .enum(["none", "draft", "shared-via-email", "scheduled", "charge"])
        .optional(),
    participants: zod_1.z.array(zod_1.z.string()).optional(),
    supervisors: zod_1.z.array(zod_1.z.string()).optional(),
    organizationSettings: PackageInstanceOrganizationSettings.optional(),
    membersSettings: zod_1.z
        .array(zod_1.z.object({ memberIds: zod_1.z.array(zod_1.z.string()), schedulerId: zod_1.z.string() }))
        .optional(),
    curriculumAssignments: zod_1.z
        .array(zod_1.z.object({ schedulerId: zod_1.z.string(), participantId: zod_1.z.string() }))
        .optional(),
    calculateRollover: zod_1.z.boolean().optional(),
    priceId: zod_1.z.string().optional(),
});
const bookPackage_Body = zod_1.z.object({
    packageId: zod_1.z.string(),
    quantity: zod_1.z.number().int().optional(),
});
const ClientPaymentMethod = zod_1.z
    .object({
    id: zod_1.z.string(),
    type: zod_1.z.enum(["card", "us_bank_account"]),
    isDefault: zod_1.z.boolean(),
    card: zod_1.z
        .object({
        brand: zod_1.z.string(),
        last4: zod_1.z.string(),
        expirationMonth: zod_1.z.number().int(),
        expirationYear: zod_1.z.number().int(),
    })
        .partial()
        .passthrough(),
    bankAccount: zod_1.z
        .object({
        bankName: zod_1.z.string(),
        last4: zod_1.z.string(),
        isVerified: zod_1.z.boolean(),
        currency: zod_1.z.string(),
    })
        .partial()
        .passthrough(),
})
    .partial()
    .passthrough();
const ClientPaymentMethods = zod_1.z
    .object({ paymentMethods: zod_1.z.array(ClientPaymentMethod) })
    .partial()
    .passthrough();
const clientSignup_Body = zod_1.z.object({
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    email: zod_1.z.string(),
});
const FormStatus = zod_1.z.enum([
    "draft",
    "scheduled",
    "shared",
    "viewed",
    "pending",
    "submitted",
    "active",
    "deleted",
]);
const Form = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    status: FormStatus,
    totalQuestions: zod_1.z.number(),
    totalAnswered: zod_1.z.number(),
    client: zod_1.z.object({
        id: zod_1.z.string(),
        firstName: zod_1.z.string().optional(),
        lastName: zod_1.z.string().optional(),
        email: zod_1.z.string(),
    }),
});
const InternalForm = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    status: FormStatus,
    totalQuestions: zod_1.z.number(),
    totalAnswered: zod_1.z.number(),
    account: zod_1.z.object({
        id: zod_1.z.string(),
        firstName: zod_1.z.string().optional(),
        lastName: zod_1.z.string().optional(),
        email: zod_1.z.string(),
    }),
});
const Reconciliation = zod_1.z.object({
    invoiceId: zod_1.z.string(),
    totalSessionsInHours: zod_1.z.number().optional(),
    totalAmount: zod_1.z.number().optional(),
    currency: zod_1.z.string().optional(),
    isApproved: zod_1.z.boolean().optional(),
    needsAttention: zod_1.z.boolean().optional(),
    paymentNeedsAttention: zod_1.z.boolean().optional(),
    isLastInvoice: zod_1.z.boolean().optional(),
    cutOffDate: zod_1.z.string().optional(),
    status: InvoiceStatus.optional(),
    invoiceMethod: InvoiceMethod.optional(),
    packageInstance: zod_1.z
        .object({ id: zod_1.z.string(), title: zod_1.z.string(), icon: zod_1.z.string() })
        .optional(),
    client: zod_1.z
        .object({
        id: zod_1.z.string(),
        firstName: zod_1.z.string().optional(),
        lastName: zod_1.z.string().optional(),
        labels: zod_1.z.array(zod_1.z.string()),
    })
        .optional(),
});
const PaginatedInvoice = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string().optional(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    status: InvoiceStatus,
    total: zod_1.z.number(),
    currency: zod_1.z.string(),
    kind: InvoiceKind.optional(),
    client: zod_1.z
        .object({
        id: zod_1.z.string(),
        firstName: zod_1.z.string().optional(),
        lastName: zod_1.z.string().optional(),
        email: zod_1.z.string().optional(),
    })
        .optional(),
    taxType: zod_1.z
        .object({ name: zod_1.z.string(), percentage: zod_1.z.number() })
        .partial()
        .nullish(),
    date: zod_1.z.string().datetime({ offset: true }).optional(),
    paymentNeedsAttention: zod_1.z.boolean().optional(),
});
const RefundReason = zod_1.z.enum([
    "duplicate",
    "fraudulent",
    "requested_by_customer",
]);
const Refund = zod_1.z.object({
    amountInCents: zod_1.z.number(),
    reason: RefundReason.nullish(),
    details: zod_1.z.string().optional(),
    stripeRefundId: zod_1.z.string(),
    status: zod_1.z.string(),
    refundedBy: zod_1.z.string().optional(),
    refundedAt: zod_1.z.string().datetime({ offset: true }),
});
const CreditNoteReason = zod_1.z.enum([
    "duplicate",
    "fraudulent",
    "order_change",
    "product_unsatisfactory",
]);
const CreditNote = zod_1.z.object({
    amountInCents: zod_1.z.number(),
    cnNumber: zod_1.z.string(),
    reason: CreditNoteReason.nullable(),
    dateIssued: zod_1.z.string(),
    stripeUrl: zod_1.z.string(),
    stripeCreditNoteId: zod_1.z.string(),
    stripeRefundId: zod_1.z.string().nullish(),
    issuedBy: zod_1.z.string().optional(),
    details: zod_1.z.string().optional(),
});
const Outcome = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    status: zod_1.z.string().optional(),
    category: zod_1.z.string(),
    color: zod_1.z.object({ background: zod_1.z.string(), foreground: zod_1.z.string() }).partial(),
    order: zod_1.z.number().optional(),
    icon: zod_1.z.string(),
    isDefault: zod_1.z.boolean().optional(),
});
const refundInvoice_Body = zod_1.z.object({
    amount: zod_1.z.number(),
    reason: RefundReason,
    details: zod_1.z.string().optional(),
});
const CreditNoteType = zod_1.z.enum(["refund", "credit", "out_of_band"]);
const createCreditNote_Body = zod_1.z.object({
    amount: zod_1.z.number(),
    reason: CreditNoteReason,
    creditType: CreditNoteType.optional(),
    details: zod_1.z.string().optional(),
    stripeRefundId: zod_1.z.string().optional(),
});
const postBatchApproveInvoices_Body = zod_1.z
    .object({
    ids: zod_1.z.array(zod_1.z.object({ invoiceId: zod_1.z.string(), clientId: zod_1.z.string() })),
    all: zod_1.z.object({
        cycle: zod_1.z.object({ start: zod_1.z.string(), end: zod_1.z.string() }),
        needsAttention: zod_1.z.boolean().optional(),
        invoiceStatus: zod_1.z
            .enum(["shared", "failed", "paid", "scheduled", "draft", "open"])
            .optional(),
        clientLabelId: zod_1.z.string().optional(),
        invoiceMethod: zod_1.z.enum(["auto", "manual"]).optional(),
        idsToIgnore: zod_1.z.array(zod_1.z.string()).optional(),
    }),
})
    .partial();
const IntuitAccounts = zod_1.z.array(zod_1.z.unknown());
const QuickBooksAccounts = zod_1.z.array(zod_1.z.unknown());
const refundType = zod_1.z.enum(["refund_receipt", "expense", "both"]);
const updateRealmConfig_Body = zod_1.z
    .object({
    realmId: zod_1.z.string(),
    enabledClientPush: zod_1.z.boolean().optional().default(true),
    enabledClientPull: zod_1.z.boolean().optional(),
    refundType: refundType.optional().default("refund_receipt"),
})
    .passthrough();
const saveAccountMap_Body = zod_1.z.record(zod_1.z.record(zod_1.z
    .object({ creditAccountId: zod_1.z.string(), debitAccountId: zod_1.z.string() })
    .partial()
    .passthrough()));
const postBatchApproveBillableRequests_Body = zod_1.z
    .object({
    items: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string() })),
    all: zod_1.z.object({
        query: zod_1.z
            .object({ start: zod_1.z.string(), end: zod_1.z.string(), accountId: zod_1.z.string() })
            .partial(),
        idsToIgnore: zod_1.z.array(zod_1.z.string()).optional(),
    }),
})
    .partial();
const deleteAppointment_Body = zod_1.z
    .object({ series: zod_1.z.boolean(), soft: zod_1.z.boolean(), upcomingOnly: zod_1.z.boolean() })
    .partial()
    .passthrough();
const createClientOrganization_Body = zod_1.z.object({
    type: zod_1.z.enum(["family", "company"]),
    title: zod_1.z.string(),
    memberIds: zod_1.z.array(zod_1.z.string()),
    primaryContact: zod_1.z.string(),
    assigneeIds: zod_1.z.array(zod_1.z.string()),
    billingContact: zod_1.z.string(),
    billing: zod_1.z.object({
        email: zod_1.z.string(),
        address: zod_1.z
            .object({
            name: zod_1.z.string(),
            street: zod_1.z.string(),
            city: zod_1.z.string(),
            state: zod_1.z.string(),
            zip: zod_1.z.string(),
            country: zod_1.z.string(),
        })
            .partial()
            .optional(),
    }),
    statusId: zod_1.z.string().nullish(),
});
const updateClientOrganization_Body = zod_1.z
    .object({
    title: zod_1.z.string(),
    memberIds: zod_1.z.array(zod_1.z.string()),
    primaryContact: zod_1.z.string(),
    assigneeIds: zod_1.z.array(zod_1.z.string()),
    billingContact: zod_1.z.string(),
    billing: zod_1.z
        .object({
        email: zod_1.z.string(),
        address: zod_1.z
            .object({
            name: zod_1.z.string(),
            street: zod_1.z.string(),
            city: zod_1.z.string(),
            state: zod_1.z.string(),
            zip: zod_1.z.string(),
            country: zod_1.z.string(),
        })
            .partial(),
    })
        .partial(),
    statusId: zod_1.z.string().nullable(),
})
    .partial();
const updateCouponsForPackageTemplates_Body = zod_1.z
    .object({ packageIds: zod_1.z.array(zod_1.z.string()), couponId: zod_1.z.string() })
    .passthrough();
const PackageTemplateItem = zod_1.z
    .object({
    productId: zod_1.z.string().nullish(),
    schedulerId: zod_1.z.string(),
    groupScheduler: zod_1.z.boolean().nullish(),
    quantity: zod_1.z.number(),
    order: zod_1.z.number().nullish(),
    usagePricing: UsagePricing.optional(),
    suggestedFrequency: SuggestedFrequency.optional(),
    billingRateId: zod_1.z.string().nullish(),
    curriculum: zod_1.z.boolean().nullish(),
    isUnlimited: zod_1.z.boolean().optional(),
})
    .passthrough();
const PackagePaymentType = zod_1.z.enum(["one-time", "split-payments"]);
const PackagePaymentSplitPeriod = zod_1.z.enum(["months", "weeks"]);
const PackagePaymentOptionRequest = zod_1.z
    .object({
    type: PackagePaymentType,
    id: zod_1.z.string().optional(),
    amount: zod_1.z.number(),
    currency: zod_1.z.string(),
    taxTypeId: zod_1.z.string(),
    splits: zod_1.z
        .array(zod_1.z
        .object({
        unit: zod_1.z.string(),
        amount: zod_1.z.number(),
        itemAmount: zod_1.z.number().nullish(),
        dueOn: zod_1.z.number(),
        period: PackagePaymentSplitPeriod,
    })
        .passthrough())
        .optional(),
})
    .passthrough();
const PackageContentType = zod_1.z.enum(["sessions", "time"]);
const PackageTimeType = zod_1.z.enum(["minutes", "hours"]);
const PackageType = zod_1.z.enum([
    "recurring",
    "one-time",
    "flexible",
    "usage",
    "subscription",
]);
const PackageFrequency = zod_1.z
    .object({ total: zod_1.z.number(), type: PackageFrequencyType })
    .passthrough();
const PackageBillingRateType = zod_1.z.enum(["multi", "single"]);
const PackageDepositRule = zod_1.z.enum(["start-of-engagement", "end-of-engagement"]);
const SmartActionTemplateEventExtended = zod_1.z
    .object({
    timming: SmartActionEventTimming,
    trigger: SmartActionEventTrigger,
    settings: zod_1.z
        .object({
        acceptedOutcomes: zod_1.z.array(zod_1.z.string()).nullable(),
        appointmentCount: zod_1.z.number().nullable(),
    })
        .partial()
        .passthrough()
        .nullish(),
    when: SmartActionTemplateEventWhen.optional(),
})
    .passthrough();
const SmartActionTemplateExtended = zod_1.z
    .object({
    event: SmartActionTemplateEventExtended,
    action: SmartActionTemplateAction,
})
    .passthrough();
const StorageFile = zod_1.z
    .object({
    url: zod_1.z.string(),
    fileName: zod_1.z.string(),
    size: zod_1.z.number(),
    contentType: zod_1.z.string(),
    fullPath: zod_1.z.string().optional(),
    bucket: zod_1.z.string().optional(),
    extension: zod_1.z.string().optional(),
})
    .passthrough();
const TierContentType = zod_1.z.enum(["time", "sessions"]);
const TierContentUnit = zod_1.z.enum(["minutes", "hours", "unit"]);
const TierContentPeriod = zod_1.z.enum(["weeks", "months", "years"]);
const TierContent = zod_1.z
    .object({
    type: TierContentType,
    quantity: zod_1.z.number(),
    unit: TierContentUnit,
    period: TierContentPeriod,
    schedulers: zod_1.z.array(zod_1.z.string()),
    unlimitedSchedulerIds: zod_1.z.array(zod_1.z.string()).optional(),
})
    .passthrough();
const PaymentMethodEnum = zod_1.z.enum(["cc", "ach"]);
const TierPriceInterval = zod_1.z.enum(["month", "week", "year"]);
const CreateTier = zod_1.z.object({
    title: zod_1.z.string(),
    icon: StorageFile.nullish(),
    description: zod_1.z.string().optional(),
    itemizations: zod_1.z.array(zod_1.z.string()).optional(),
    content: TierContent,
    onTrackNotifications: OnTrackNotifications.nullish(),
    onTrackRules: OnTrackRules.nullish(),
    isPopular: zod_1.z.boolean().optional(),
    hideFromBookingFlow: zod_1.z.boolean().optional(),
    serviceFee: zod_1.z
        .object({
        amount: zod_1.z.number(),
        type: zod_1.z.enum(["percentage", "flat"]).optional(),
        title: zod_1.z.string().optional(),
        appliedToPaymentMethods: zod_1.z.array(PaymentMethodEnum).min(1),
        agreedToTerms: zod_1.z.boolean().optional(),
    })
        .passthrough()
        .nullish(),
    prices: zod_1.z.array(zod_1.z
        .object({
        id: zod_1.z.string().optional(),
        amount: zod_1.z.number(),
        active: zod_1.z.boolean(),
        order: zod_1.z.number().optional(),
        recurring: zod_1.z
            .object({ interval: TierPriceInterval, intervalCount: zod_1.z.number() })
            .passthrough(),
        priceInfo: zod_1.z.string().optional(),
    })
        .passthrough()),
});
const _0 = zod_1.z
    .object({
    amount: zod_1.z.number(),
    type: zod_1.z.enum(["percentage", "flat"]).optional(),
    title: zod_1.z.string().optional(),
    appliedToPaymentMethods: zod_1.z.array(PaymentMethodEnum).min(1),
    agreedToTerms: zod_1.z.boolean().optional(),
})
    .passthrough();
const expiration = zod_1.z
    .object({
    date: zod_1.z.string().datetime({ offset: true }).nullish(),
    type: zod_1.z.enum(["date", "months", "days"]),
    quantity: zod_1.z.number().nullish(),
})
    .passthrough();
const PackageTemplatePayload = zod_1.z
    .object({
    title: zod_1.z.string(),
    slug: zod_1.z.string(),
    description: zod_1.z.string(),
    internalName: zod_1.z.string().optional(),
    icon: zod_1.z.string(),
    items: zod_1.z.array(PackageTemplateItem),
    paymentOptions: zod_1.z.array(PackagePaymentOptionRequest),
    secret: zod_1.z.boolean().nullish(),
    publicOrder: zod_1.z.number().nullish(),
    distributeSessions: zod_1.z.boolean().nullish(),
    totalSessions: zod_1.z.number().nullish(),
    contentType: PackageContentType.nullish(),
    timeType: PackageTimeType.nullish(),
    autocomplete: zod_1.z.boolean().nullish(),
    packageType: PackageType.nullish(),
    frequency: PackageFrequency.nullish(),
    rollOver: zod_1.z.boolean().nullish(),
    billingRateId: zod_1.z.string().nullish(),
    packageBillingRateType: PackageBillingRateType.nullish(),
    acceptedOutcomes: zod_1.z.array(zod_1.z.string()).nullish(),
    autoCancelOutcome: zod_1.z.boolean().nullish(),
    usageInvoicing: UsagePackageInvoicing.nullish(),
    allowFutureBooking: zod_1.z.boolean().nullish(),
    locked: zod_1.z.boolean().nullish(),
    depositRule: PackageDepositRule.nullish(),
    coupons: zod_1.z.array(zod_1.z.object({ value: zod_1.z.string() }).passthrough()).optional(),
    onTrackEnabled: zod_1.z.boolean().nullish(),
    enableAtRisk: zod_1.z.boolean().nullish(),
    smartActions: zod_1.z.array(SmartActionTemplateExtended).nullish(),
    onTrackNotifications: OnTrackNotifications.nullish(),
    onTrackRules: OnTrackRules.nullish(),
    tiers: zod_1.z.array(CreateTier).nullish(),
    serviceFee: _0.nullish(),
    earliestStartDate: zod_1.z.string().nullish(),
    paymentSettings: zod_1.z
        .object({ taxTypeId: zod_1.z.string(), currency: zod_1.z.string() })
        .passthrough()
        .optional(),
    expiration: expiration.nullish(),
    cancellationFormTemplateId: zod_1.z.string().nullish(),
    allowClientTierChanges: zod_1.z.boolean().optional(),
})
    .passthrough();
const PackageTemplateStatus = zod_1.z.enum(["active", "inactive", "deleted"]);
const PackagePaymentSplit = zod_1.z
    .object({
    unit: zod_1.z.string(),
    amount: zod_1.z.number(),
    itemAmount: zod_1.z.number().nullish(),
    dueOn: zod_1.z.number(),
    period: PackagePaymentSplitPeriod,
    total: zod_1.z.number(),
})
    .passthrough();
const PackagePaymentOption = zod_1.z
    .object({
    type: PackagePaymentType,
    id: zod_1.z.string().optional(),
    amount: zod_1.z.number(),
    currency: zod_1.z.string(),
    taxTypeId: zod_1.z.string(),
    splits: zod_1.z.array(PackagePaymentSplit).optional(),
})
    .passthrough();
const TierPrice = zod_1.z
    .object({
    id: zod_1.z.string(),
    amount: zod_1.z.number(),
    title: zod_1.z.string(),
    active: zod_1.z.boolean(),
    order: zod_1.z.number(),
    recurring: zod_1.z
        .object({ interval: TierPriceInterval, intervalCount: zod_1.z.number() })
        .passthrough(),
    priceInfo: zod_1.z.string().optional(),
})
    .passthrough();
const Tier = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    icon: StorageFile.nullish(),
    description: zod_1.z.string().optional(),
    itemizations: zod_1.z.array(zod_1.z.string()).optional(),
    content: TierContent,
    onTrackNotifications: OnTrackNotifications.nullish(),
    onTrackRules: OnTrackRules.nullish(),
    isPopular: zod_1.z.boolean(),
    serviceFee: zod_1.z
        .object({
        amount: zod_1.z.number(),
        appliedToPaymentMethods: zod_1.z.array(PaymentMethodEnum),
        title: zod_1.z.string().optional(),
        type: zod_1.z.enum(["percentage", "flat"]),
    })
        .passthrough()
        .nullish(),
    prices: zod_1.z.array(TierPrice),
    startingPriceTitle: zod_1.z.string().optional(),
    hideFromBookingFlow: zod_1.z.boolean().optional(),
})
    .passthrough();
const PackageTemplate = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    status: PackageTemplateStatus,
    slug: zod_1.z.string(),
    description: zod_1.z.string(),
    internalName: zod_1.z.string().optional(),
    icon: zod_1.z.string(),
    items: zod_1.z.array(PackageTemplateItem),
    paymentOptions: zod_1.z.array(PackagePaymentOption),
    secret: zod_1.z.boolean().nullish(),
    publicOrder: zod_1.z.number().nullish(),
    distributeSessions: zod_1.z.boolean().nullish(),
    totalSessions: zod_1.z.number().nullish(),
    contentType: PackageContentType.nullish(),
    timeType: PackageTimeType.nullish(),
    autocomplete: zod_1.z.boolean().nullish(),
    packageType: PackageType.nullish(),
    frequency: PackageFrequency.nullish(),
    rollOver: zod_1.z.boolean().nullish(),
    billingRateId: zod_1.z.string().nullish(),
    packageBillingRateType: PackageBillingRateType.nullish(),
    acceptedOutcomes: zod_1.z.array(zod_1.z.string()).nullish(),
    autoCancelOutcome: zod_1.z.boolean().nullish(),
    usageInvoicing: UsagePackageInvoicing.nullish(),
    allowFutureBooking: zod_1.z.boolean().nullish(),
    locked: zod_1.z.boolean().nullish(),
    depositRule: PackageDepositRule.nullish(),
    coupons: zod_1.z.array(zod_1.z.object({ value: zod_1.z.string() }).passthrough()).optional(),
    onTrackEnabled: zod_1.z.boolean().nullish(),
    enableAtRisk: zod_1.z.boolean().nullish(),
    smartActions: zod_1.z.array(SmartActionTemplateExtended).nullish(),
    onTrackNotifications: OnTrackNotifications.nullish(),
    onTrackRules: OnTrackRules.nullish(),
    tiers: zod_1.z.array(Tier).nullish(),
    earliestStartDate: zod_1.z.string().nullish(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
    serviceFee: _0.nullish(),
    couponIds: zod_1.z.array(zod_1.z.string()).optional(),
    paymentSettings: zod_1.z
        .object({ taxTypeId: zod_1.z.string(), currency: zod_1.z.string() })
        .passthrough()
        .optional(),
    expiration: zod_1.z
        .object({
        date: zod_1.z.string().datetime({ offset: true }).nullish(),
        type: zod_1.z.enum(["date", "months", "days"]),
        quantity: zod_1.z.number().nullish(),
    })
        .passthrough()
        .nullish(),
    cancellationFormTemplateId: zod_1.z.string().nullish(),
    allowClientTierChanges: zod_1.z.boolean().optional(),
})
    .passthrough();
const updatePackageTemplate_Body = PackageTemplatePayload.and(zod_1.z
    .object({
    tiers: zod_1.z
        .array(CreateTier.and(zod_1.z.object({ id: zod_1.z.string().nullable() }).partial().passthrough()))
        .nullable(),
})
    .partial()
    .passthrough());
const GroupSchedulerTimeslot = zod_1.z.object({
    startTime: zod_1.z.string().datetime({ offset: true }),
    endTime: zod_1.z.string().datetime({ offset: true }),
    duration: zod_1.z.number(),
    id: zod_1.z.string(),
    locationType: zod_1.z.string().optional(),
    location: zod_1.z.string().optional(),
    attendanceTimeslotKey: zod_1.z.string(),
    calendar: zod_1.z
        .object({
        id: zod_1.z.string(),
        integration: BaseIntegration.and(IntegrationProvider),
    })
        .optional(),
    recurring: zod_1.z
        .object({ date: zod_1.z.string(), canUpdateSeries: zod_1.z.boolean() })
        .optional(),
    title: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
    organizer: zod_1.z
        .object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        email: zod_1.z.string(),
        avatarUrl: zod_1.z.string().optional(),
    })
        .optional(),
    clientAttendees: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        email: zod_1.z.string(),
        attendanceId: zod_1.z.string(),
    }))
        .optional(),
});
const SlotAttendance = zod_1.z.object({
    id: zod_1.z.string(),
    clientId: zod_1.z.string().optional(),
    packageInstanceId: zod_1.z.string(),
    groupSchedulerId: zod_1.z.string(),
    timeslotId: zod_1.z.string().optional(),
    recurringTimeslotDate: zod_1.z.string().optional(),
    attendanceTimeslotKey: zod_1.z.string().optional(),
    joined: zod_1.z.string().datetime({ offset: true }).optional(),
    status: zod_1.z.enum(["cancelled", "invited", "booked", "joined"]).optional(),
    attending: zod_1.z.boolean(),
});
const joinCurriculumScheduler_Body = zod_1.z
    .object({ packageInstanceId: zod_1.z.string(), clientId: zod_1.z.string().optional() })
    .passthrough();
const leaveCurriculumScheduler_Body = zod_1.z
    .object({
    packageInstanceId: zod_1.z.string(),
    reason: zod_1.z.string().optional(),
    memberId: zod_1.z.string().optional(),
})
    .passthrough();
const CreateGroupSchedulerTimeslot = zod_1.z.object({
    startTime: zod_1.z.string().datetime({ offset: true }),
    endTime: zod_1.z.string().datetime({ offset: true }),
    duration: zod_1.z.number(),
    recurringInformation: zod_1.z
        .object({ frequency: zod_1.z.enum(["workdays", "weekly"]) })
        .optional(),
});
const RecurringTimeslotInformation = zod_1.z.object({
    date: zod_1.z.string(),
    applyToFollowing: zod_1.z.boolean(),
});
const ConfigureGroupSchedulerTimeslot = zod_1.z
    .object({
    title: zod_1.z.string(),
    description: zod_1.z.string(),
    calendar: zod_1.z.object({
        id: zod_1.z.string(),
        integration: BaseIntegration.and(IntegrationProvider),
    }),
    communication: zod_1.z
        .object({ locationType: zod_1.z.string(), location: zod_1.z.string() })
        .partial(),
    recurring: RecurringTimeslotInformation,
})
    .partial();
const bookGroupSchedulerTimeslot_Body = zod_1.z
    .object({
    clientId: zod_1.z.string(),
    packageInstanceId: zod_1.z.string(),
    recurring: RecurringTimeslotInformation.optional(),
})
    .passthrough();
const cancelGroupSchedulerTimeslot_Body = zod_1.z
    .object({
    groupSchedulerAttendanceId: zod_1.z.string(),
    recurring: RecurringTimeslotInformation.optional(),
    reason: zod_1.z.string().optional(),
})
    .passthrough();
const deleteGroupSchedulerTimeslot_Body = zod_1.z
    .object({ recurring: RecurringTimeslotInformation })
    .partial()
    .passthrough();
const deleteGroupSchedulerAttendance_Body = zod_1.z
    .object({
    attendanceId: zod_1.z.string(),
    reason: zod_1.z.string().optional(),
    memberId: zod_1.z.string().optional(),
    recurring: RecurringTimeslotInformation.optional(),
})
    .passthrough();
const AccountsPayable = zod_1.z.object({
    id: zod_1.z.string(),
    totalHours: zod_1.z.number(),
    totalSessions: zod_1.z.number(),
    totalAmount: zod_1.z.number(),
    rate: zod_1.z.string(),
    currency: zod_1.z.string(),
    isPaid: zod_1.z.boolean(),
    memberId: zod_1.z.string(),
    memberName: zod_1.z.string().optional(),
});
const AccountsPayableTransaction = zod_1.z.object({
    client: zod_1.z
        .object({ id: zod_1.z.string(), name: zod_1.z.string(), status: zod_1.z.string() })
        .partial()
        .passthrough()
        .optional(),
    appointment: zod_1.z
        .object({ id: zod_1.z.string(), outcome: zod_1.z.string() })
        .partial()
        .passthrough()
        .optional(),
    amount: zod_1.z.number(),
    activityDate: zod_1.z.string().optional(),
    rateValue: zod_1.z.number().optional(),
    rateTitle: zod_1.z.string().optional(),
    currency: zod_1.z.string(),
    duration: zod_1.z.number(),
    description: zod_1.z.string(),
    accountsPayableType: zod_1.z.enum([
        "appointment",
        "billableRequest",
        "groupAppointment",
    ]),
});
const markInvoicesAsPaidOrUnpaid_Body = zod_1.z.object({
    invoiceIds: zod_1.z.array(zod_1.z.string()),
    action: zod_1.z.enum(["pay", "unpay"]),
});
const exportAccountsPayableToGoogleSheets_Body = zod_1.z.object({
    start: zod_1.z.string().datetime({ offset: true }),
    end: zod_1.z.string().datetime({ offset: true }),
    memberId: zod_1.z.string().optional(),
    invoicePaidStatus: zod_1.z.enum(["paid", "unpaid"]).optional().default("unpaid"),
    includeZeroInvoices: zod_1.z.boolean().optional(),
});
const OnTrack = zod_1.z.object({
    id: zod_1.z.string(),
    clientName: zod_1.z.string(),
    clientId: zod_1.z.string(),
    packageTitle: zod_1.z.string(),
    lastSessionDate: zod_1.z.string().optional(),
    daysSinceLastSession: zod_1.z.number().optional(),
    nextSessionDate: zod_1.z.string().optional(),
    outstandingAmount: zod_1.z.string(),
    onTrackStatus: OnTrackStatus.optional(),
});
const Scheduler = zod_1.z.object({
    title: zod_1.z.string(),
    status: zod_1.z.enum(["active", "inactive", "deleted"]),
    slug: zod_1.z.string().optional(),
    smartActions: zod_1.z.array(zod_1.z.object({}).partial().passthrough()).optional(),
    messagingInvite: zod_1.z.boolean().optional(),
    icon: zod_1.z.string(),
    duration: zod_1.z.number().optional(),
    communication: zod_1.z.array(zod_1.z
        .object({
        value: zod_1.z.string(),
        memberId: zod_1.z.string().optional(),
        roundRobinMemberIds: zod_1.z.array(zod_1.z.string()).optional(),
        extra: zod_1.z.string().optional(),
    })
        .passthrough()),
    availabilityId: zod_1.z.string().nullish(),
    description: zod_1.z.string().optional(),
    sharedWith: zod_1.z.array(zod_1.z.string()).optional(),
    bufferTimeAfter: zod_1.z.number().nullish(),
    bufferTimeBefore: zod_1.z.number().nullish(),
    maximumLeadTimeDays: zod_1.z.number().nullish(),
    mimimumLeadTimeDays: zod_1.z.number().nullish(),
    productId: zod_1.z.string().nullish(),
    publicOrder: zod_1.z.number().optional(),
    secret: zod_1.z.boolean().optional(),
    startTimeInterval: zod_1.z.string().optional(),
    maximumDayUsage: zod_1.z.number().nullish(),
    minimumLeadTimeHours: zod_1.z.number().nullish(),
    maximumWeekUsage: zod_1.z.number().nullish(),
    roundRobin: zod_1.z
        .object({
        members: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), availabilityId: zod_1.z.string() }).passthrough()),
        priority: zod_1.z.enum(["availability", "assignee"]).optional(),
        memberSwitching: zod_1.z.boolean().optional(),
        ownerChange: zod_1.z.boolean().optional(),
        roster: zod_1.z.boolean().optional(),
    })
        .passthrough()
        .nullish(),
    reminders: zod_1.z.array(zod_1.z.object({}).partial().passthrough()).optional(),
    reschedulingOptions: zod_1.z
        .object({
        allowedActions: zod_1.z.enum([
            "none",
            "cancel",
            "reschedule",
            "cancel_reschedule",
        ]),
        minimumNotice: zod_1.z.object({ duration: zod_1.z.number() }).passthrough(),
        reasonRequired: zod_1.z.boolean(),
    })
        .passthrough()
        .optional(),
    groupScheduler: zod_1.z
        .object({
        maxParticipants: zod_1.z.number().nullish(),
        type: zod_1.z.enum(["ongoing", "curriculum"]),
    })
        .passthrough()
        .optional(),
    billingRateId: zod_1.z.string().nullish(),
});
const StripeProductPriceItem = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    currency: zod_1.z.string(),
    amount: zod_1.z.number().optional(),
})
    .passthrough();
const StripeProductItem = zod_1.z
    .object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    startingPriceTitle: zod_1.z.string(),
    description: zod_1.z.string(),
    prices: zod_1.z.array(StripeProductPriceItem),
    features: zod_1.z.array(zod_1.z.string()),
    imageUrl: zod_1.z.string().optional(),
})
    .passthrough();
const ClientStatusGroup = zod_1.z.enum([
    "pre-pipeline",
    "pre-purchase",
    "lost",
    "qualified",
    "customer",
    "churn",
]);
const ClientStatus = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    order: zod_1.z.number(),
    styles: zod_1.z.object({ text: zod_1.z.string(), background: zod_1.z.string() }),
    group: ClientStatusGroup,
    createdAt: zod_1.z.string(),
});
const WorkflowConfiguration = zod_1.z.object({
    id: zod_1.z.string(),
    displayName: zod_1.z.string(),
    icon: zod_1.z.string(),
    summary: zod_1.z.string(),
    description: zod_1.z.string(),
    keywords: zod_1.z.array(zod_1.z.string()).optional(),
});
const WorkflowExecutionCounts = zod_1.z
    .object({
    all: zod_1.z.number(),
    running: zod_1.z.number(),
    completed: zod_1.z.number(),
    failed: zod_1.z.number(),
    terminated: zod_1.z.number(),
})
    .partial()
    .passthrough();
const WorkflowStatus = zod_1.z.enum([
    "unknown",
    "running",
    "completed",
    "failed",
    "terminated",
    "timed_out",
]);
const WorkflowExecution = zod_1.z
    .object({
    id: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    workflowName: zod_1.z.string(),
    workflowDisplayName: zod_1.z.string().optional(),
    executionId: zod_1.z.string(),
    status: WorkflowStatus,
    result: zod_1.z.object({}).partial().passthrough().optional(),
    startedAt: zod_1.z.string().datetime({ offset: true }),
    completedAt: zod_1.z.string().datetime({ offset: true }).nullish(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
    deletedAt: zod_1.z.string().datetime({ offset: true }).nullish(),
    isDeleted: zod_1.z.boolean().optional(),
})
    .passthrough();
const WorkflowStep = zod_1.z.object({
    id: zod_1.z.string(),
    requestId: zod_1.z.string().optional(),
    action: ActivityAction,
    actorId: zod_1.z.string(),
    actorType: ActorType,
    resourceId: zod_1.z.string(),
    resourceType: ResourceType,
    organizationId: zod_1.z.string(),
    clientId: zod_1.z.string().optional(),
    timestamp: zod_1.z.string().datetime({ offset: true }),
    data: zod_1.z.object({}).partial().passthrough().optional(),
    status: zod_1.z.enum(["success", "failed"]).optional(),
});
const signalWorkflowEvent_Body = zod_1.z
    .object({
    name: zod_1.z.string(),
    type: zod_1.z.string(),
    payload: zod_1.z.object({}).partial().passthrough(),
})
    .passthrough();
const AgentConfiguration = WorkflowConfiguration.and(zod_1.z.object({
    defaultSchedule: zod_1.z.string(),
    relatedWorkflows: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string() })),
    stripeProductId: zod_1.z.string(),
    stripePriceIds: zod_1.z.array(zod_1.z
        .object({
        id: zod_1.z.string(),
        trialPeriodDays: zod_1.z.number().optional(),
        unitAmount: zod_1.z.number().optional(),
        currency: zod_1.z.string().optional(),
        type: zod_1.z.string().optional(),
        intervalCount: zod_1.z.number().optional(),
        interval: zod_1.z.string().optional(),
    })
        .passthrough()),
    maxQuantity: zod_1.z.number(),
}));
const AgentResponse = zod_1.z.object({
    id: zod_1.z.string(),
    agentId: zod_1.z.string(),
    status: zod_1.z.enum(["enabled", "disabled", "deleted"]),
    quantity: zod_1.z.number().int(),
    stripeSubscriptionId: zod_1.z.string(),
    scheduleIds: zod_1.z.array(zod_1.z.string()),
    optInSettings: zod_1.z.record(zod_1.z.boolean()).optional(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
    createdBy: zod_1.z.string(),
    updatedBy: zod_1.z.string(),
});
const activateAgent_Body = zod_1.z.object({
    stripeProductId: zod_1.z.string(),
    stripePriceId: zod_1.z.string(),
    trialPeriodDays: zod_1.z.number().int().optional(),
    quantity: zod_1.z.number().int().optional().default(1),
    optInSettings: zod_1.z.record(zod_1.z.boolean()).optional(),
});
const ActivityLogEntry = zod_1.z.object({
    id: zod_1.z.string(),
    requestId: zod_1.z.string().optional(),
    action: ActivityAction,
    actorId: zod_1.z.string(),
    actorType: ActorType,
    resourceId: zod_1.z.string(),
    resourceType: ResourceType,
    organizationId: zod_1.z.string(),
    clientId: zod_1.z.string().optional(),
    timestamp: zod_1.z.string().datetime({ offset: true }),
    data: zod_1.z.object({}).partial().passthrough().optional(),
});
const OrganizationId = zod_1.z.string();
const InvoiceStatusQuery = zod_1.z.enum([
    "all",
    "succeeded",
    "shared",
    "failed",
    "attention",
    "refunded",
]);
const IntuitAccount = zod_1.z.object({
    id: zod_1.z.string(),
    realmId: zod_1.z.string(),
    name: zod_1.z.string().optional(),
    createdAt: zod_1.z.string().datetime({ offset: true }).optional(),
    updatedAt: zod_1.z.string().datetime({ offset: true }).optional(),
    deletedAt: zod_1.z.string().datetime({ offset: true }).optional(),
    deletedBy: zod_1.z.string().optional(),
    addedBy: zod_1.z.string().optional(),
    updatedBy: zod_1.z.string().optional(),
    enabledContactPush: zod_1.z.boolean().optional(),
    enabledContactPull: zod_1.z.boolean().optional(),
    refundType: zod_1.z
        .enum(["refund_receipt", "expense", "both"])
        .optional()
        .default("refund_receipt"),
    accountMaps: zod_1.z
        .record(zod_1.z
        .object({ creditAccount: zod_1.z.string(), debitAccount: zod_1.z.string() })
        .partial()
        .passthrough())
        .optional(),
});
const QuickBooksAccount = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string().optional(),
    number: zod_1.z.string().optional(),
    type: zod_1.z.string().optional(),
});
const PackageInstanceCycle = zod_1.z
    .object({
    id: zod_1.z.string(),
    start: zod_1.z.string().datetime({ offset: true }),
    end: zod_1.z.string().datetime({ offset: true }).nullable(),
    extensions: zod_1.z.number().optional(),
    extensionHistory: zod_1.z
        .array(zod_1.z
        .object({
        extendedBy: zod_1.z.string(),
        extendedOn: zod_1.z.string().datetime({ offset: true }),
        value: zod_1.z.number(),
    })
        .passthrough())
        .optional(),
    rolledOver: zod_1.z.number().optional(),
    isPaused: zod_1.z.boolean().optional(),
    pausedOn: zod_1.z.string().datetime({ offset: true }).optional(),
    frequency: zod_1.z.number().optional(),
})
    .passthrough();
const GroupSchedulerAttendee = zod_1.z.object({ id: zod_1.z.string() }).passthrough();
const GroupSchedulerTimeslotConfiguration = zod_1.z
    .object({
    date: zod_1.z.string(),
    event: zod_1.z
        .object({
        title: zod_1.z.string(),
        mainInstructor: zod_1.z
            .object({ availabilityId: zod_1.z.string(), memberId: zod_1.z.string() })
            .passthrough(),
        communication: zod_1.z.object({ locationType: zod_1.z.string() }).passthrough(),
    })
        .passthrough(),
    attendees: zod_1.z.array(GroupSchedulerAttendee),
})
    .partial()
    .passthrough();
const SmartActionEvent = zod_1.z.object({
    timming: SmartActionEventTimming,
    trigger: SmartActionEventTrigger,
    resourceId: zod_1.z.string().nullish(),
    type: SmartActionEventType.optional(),
    settings: SmartActionEventSettings.optional(),
    customType: zod_1.z.string().nullish(),
});
const WorkflowDefinition = zod_1.z.object({
    key: zod_1.z.string(),
    displayName: zod_1.z.string(),
    context: zod_1.z.object({}).partial().passthrough().optional(),
    dsl: zod_1.z.object({
        variables: zod_1.z.object({}).partial().passthrough().optional(),
        root: zod_1.z.object({}).partial().passthrough(),
    }),
});
// Separate request body schemas
exports.requestBodySchemas = {
    updateNotificationMessages_Body,
    updateAllNotificationMessages_Body,
    publishActivityMessage_Body,
    generateContent_Body,
    createApiKey_Body,
    createNotificationMessage_Body,
    updateNotificationMessage_Body,
    createClient_Body,
    indexAppointment_Body,
    generateTimeseriesCounts_Body,
    search_Body,
    setupSessionBilling_Body,
    updateSessionBillingAcceptedOutcomes_Body,
    updateBillableReviewers_Body,
    markBillingTransactionsAsPaidOrUnpaid_Body,
    addBillingRate_Body,
    updateBillingRate_Body,
    updateBillingRateStatus_Body,
    overwriteBillingRate_Body,
    submitBillableRequest_Body,
    changeBillableRequestStatus_Body,
    updateClient_Body,
    updatePackageInstanceDuration_Body,
    updatePackageInstancePaymentOption_Body,
    updatePackageInstanceDetails_Body,
    createPackageOrder_Body,
    updateUsagePricing_Body,
    assignPackage_Body,
    bookPackage_Body,
    clientSignup_Body,
    refundInvoice_Body,
    createCreditNote_Body,
    postBatchApproveInvoices_Body,
    updateRealmConfig_Body,
    saveAccountMap_Body,
    postBatchApproveBillableRequests_Body,
    deleteAppointment_Body,
    createClientOrganization_Body,
    updateClientOrganization_Body,
    updateCouponsForPackageTemplates_Body,
    updatePackageTemplate_Body,
    joinCurriculumScheduler_Body,
    leaveCurriculumScheduler_Body,
    bookGroupSchedulerTimeslot_Body,
    cancelGroupSchedulerTimeslot_Body,
    deleteGroupSchedulerTimeslot_Body,
    deleteGroupSchedulerAttendance_Body,
    markInvoicesAsPaidOrUnpaid_Body,
    exportAccountsPayableToGoogleSheets_Body,
    signalWorkflowEvent_Body,
    activateAgent_Body,
};
// Main schemas (excluding request bodies)
exports.schemas = {
    PaginatedResponse,
    NotificationMessages,
    GenericError,
    GenericResponse,
    NotificationStatus,
    PhoneVerificationRequest,
    PhoneVerificationResponse,
    OtpVerificationRequest,
    OtpVerificationResponse,
    ActivityLogEntries,
    ActivityAction,
    ActorType,
    ResourceType,
    ActivityMessage,
    ApiKey,
    ApiKeys,
    NotificationType,
    NotificationPreview,
    NotificationMessage,
    SessionBillingCycle,
    SessionBillingCountingRule,
    AccountId,
    OutcomeId,
    SessionBillingOutcomeHistoryItem,
    SessionBillingBillableReviewer,
    SessionBillingSettings,
    Organization,
    Organizations,
    DashboardConfiguration,
    SignupRequest,
    SignupResponse,
    skipIntegrations,
    BaseIntegration,
    IntegrationProvider,
    IntegrationCalendar,
    CalendarIntegration,
    BaseIntegrationArray,
    Integrations,
    type,
    BillingRateStatus,
    BillingRate,
    BillingTransactionArtifactKind,
    BillingTransactionFulfillment,
    BillingTransaction,
    ClientSessions,
    BillableRequestStatus,
    BillableRequestHistoryEntry,
    BillableRequest,
    BillableRequestClient,
    TodaysView,
    UsagePricing,
    PackageFrequencyType,
    SuggestedFrequency,
    PackageInstanceItem,
    PackageInstancePaymentStatus,
    PackageInstancePayment,
    UsagePackageInvoiceCutOffDate,
    UsagePackageInvoicing,
    OnTrackStatus,
    OnTrackHistory,
    OnTrackRules,
    OnTrackNotification,
    OnTrackNotifications,
    PackageInstanceCard,
    PackageInstanceItemPublic,
    PackageInstancePublic,
    UpdatePackageDurationItemsRequestBody,
    UpdatePackageDurationRequestBody,
    PackageInstanceOrganizationSettings,
    InvoiceStatus,
    InvoiceFrequency,
    InvoiceCustomField,
    InvoiceItem,
    InvoiceMethod,
    InvoiceKind,
    InvoiceCredit,
    Invoice,
    ClientPaymentMethod,
    ClientPaymentMethods,
    FormStatus,
    Form,
    InternalForm,
    Reconciliation,
    PaginatedInvoice,
    RefundReason,
    Refund,
    CreditNoteReason,
    CreditNote,
    Outcome,
    CreditNoteType,
    IntuitAccounts,
    QuickBooksAccounts,
    refundType,
    PackageTemplateItem,
    PackagePaymentType,
    PackagePaymentSplitPeriod,
    PackagePaymentOptionRequest,
    PackageContentType,
    PackageTimeType,
    PackageType,
    PackageFrequency,
    PackageBillingRateType,
    PackageDepositRule,
    StorageFile,
    TierContentType,
    TierContentUnit,
    TierContentPeriod,
    TierContent,
    PaymentMethodEnum,
    TierPriceInterval,
    CreateTier,
    _0,
    expiration,
    PackageTemplatePayload,
    PackageTemplateStatus,
    PackagePaymentSplit,
    PackagePaymentOption,
    TierPrice,
    Tier,
    PackageTemplate,
    GroupSchedulerTimeslot,
    SlotAttendance,
    CreateGroupSchedulerTimeslot,
    RecurringTimeslotInformation,
    ConfigureGroupSchedulerTimeslot,
    AccountsPayable,
    AccountsPayableTransaction,
    OnTrack,
    Scheduler,
    StripeProductPriceItem,
    StripeProductItem,
    ClientStatusGroup,
    ClientStatus,
    WorkflowConfiguration,
    WorkflowExecutionCounts,
    WorkflowStatus,
    WorkflowExecution,
    WorkflowStep,
    AgentConfiguration,
    AgentResponse,
    ActivityLogEntry,
    OrganizationId,
    InvoiceStatusQuery,
    IntuitAccount,
    QuickBooksAccount,
    PackageInstanceCycle,
    GroupSchedulerAttendee,
    GroupSchedulerTimeslotConfiguration,
    WorkflowDefinition,
};
exports.smartActionSchemas = {
    SmartActionTemplateActionType,
    SmartActionTemplateActionArtifactType,
    SmartActionTemplateActionMethod,
    SmartActionTemplateActionSettings,
    SmartActionTemplateAction,
    SmartActionEventTimming,
    SmartActionEventTrigger,
    SmartActionEventType,
    SmartActionEventSettings,
    SmartActionTemplateEventWhen,
    SmartActionTemplateEvent,
    SmartActionTemplate,
    SmartActionTemplateEventExtended,
    SmartActionTemplateExtended,
    SmartActionEvent,
};
exports.packageTemplateSchemas = {
    "/organizations/:organizationId/package-templates": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/package-templates",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ id: zod_1.z.string() }) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: PackageTemplatePayload,
            },
        }),
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/package-templates",
            schema: {
                response: { [responseStatus]: zod_1.z.array(PackageTemplate) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/package-templates/:packageTemplateId": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/package-templates/:packageTemplateId",
            schema: {
                response: { [responseStatus]: PackageTemplate },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageTemplateId: zod_1.z.string(),
                }),
            },
        }),
        ["put"]: (responseStatus = "200") => ({
            method: "PUT",
            url: "/organizations/:organizationId/package-templates/:packageTemplateId",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageTemplateId: zod_1.z.string(),
                }),
                body: updatePackageTemplate_Body,
            },
        }),
    },
    "/organizations/:organizationId/package-templates/:packageTemplateId/duplicate": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/package-templates/:packageTemplateId/duplicate",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ id: zod_1.z.string() }) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageTemplateId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/package-templates/:packageTemplateId/tiers/:tierId/mark-as-popular": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/package-templates/:packageTemplateId/tiers/:tierId/mark-as-popular",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageTemplateId: zod_1.z.string(),
                    tierId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/package-templates/set-coupon": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/package-templates/set-coupon",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: updateCouponsForPackageTemplates_Body,
            },
        }),
    },
};
exports.endpointSchemas = {
    "/accounts/:accountId/get-phone-number": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/accounts/:accountId/get-phone-number",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({ phoneNumber: zod_1.z.string().nullable() })
                        .partial(),
                },
                params: zod_1.z.object({
                    accountId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/accounts/:accountId/notifications": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/accounts/:accountId/notifications",
            schema: {
                response: {
                    [responseStatus]: PaginatedResponse.and(zod_1.z.object({ data: NotificationMessages })),
                },
                querystring: zod_1.z.object({
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    before: zod_1.z.string().optional(),
                    after: zod_1.z.string().optional(),
                    status: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    accountId: zod_1.z.string(),
                }),
            },
        }),
        ["put"]: (responseStatus = "200") => ({
            method: "PUT",
            url: "/accounts/:accountId/notifications",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    accountId: zod_1.z.string(),
                }),
                body: updateNotificationMessages_Body,
            },
        }),
        ["patch"]: (responseStatus = "200") => ({
            method: "PATCH",
            url: "/accounts/:accountId/notifications",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    accountId: zod_1.z.string(),
                }),
                body: updateAllNotificationMessages_Body,
            },
        }),
    },
    "/accounts/:accountId/phone-verification/request": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/accounts/:accountId/phone-verification/request",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ sessionId: zod_1.z.string() }) },
                params: zod_1.z.object({
                    accountId: zod_1.z.string(),
                }),
                body: zod_1.z.object({ phoneNumber: zod_1.z.string() }),
            },
        }),
    },
    "/accounts/:accountId/phone-verification/verify": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/accounts/:accountId/phone-verification/verify",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ success: zod_1.z.boolean() }) },
                params: zod_1.z.object({
                    accountId: zod_1.z.string(),
                }),
                body: OtpVerificationRequest,
            },
        }),
    },
    "/activity/log/": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/activity/log/",
            schema: {
                response: {
                    [responseStatus]: PaginatedResponse.and(zod_1.z.object({ data: ActivityLogEntries })),
                },
                querystring: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    before: zod_1.z.string().optional(),
                    after: zod_1.z.string().optional(),
                    hydrate: zod_1.z.string().or(zod_1.z.array(zod_1.z.string())).optional(),
                    filter: zod_1.z.string().or(zod_1.z.array(zod_1.z.string())).optional(),
                }),
            },
        }),
    },
    "/activity/message/": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/activity/message/",
            schema: {
                response: { [responseStatus]: GenericResponse },
                body: publishActivityMessage_Body,
            },
        }),
    },
    "/agents": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/agents",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({
                        agentConfigurations: zod_1.z.array(AgentConfiguration),
                        nextPageToken: zod_1.z.string(),
                    })
                        .partial(),
                },
                querystring: zod_1.z.object({
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    cursorId: zod_1.z.string().optional(),
                    keywords: zod_1.z.string().or(zod_1.z.array(zod_1.z.string())).optional(),
                }),
            },
        }),
    },
    "/ai/conversations": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/ai/conversations",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        conversation: zod_1.z.object({ id: zod_1.z.string() }).passthrough(),
                    }),
                },
                body: zod_1.z.object({ organizationId: zod_1.z.string() }).passthrough(),
            },
        }),
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/ai/conversations",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        conversations: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), date: zod_1.z.string() })),
                    }),
                },
                querystring: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/ai/conversations/:conversationId/generate-content": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/ai/conversations/:conversationId/generate-content",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({ response: zod_1.z.string() }).partial(),
                },
                params: zod_1.z.object({
                    conversationId: zod_1.z.string(),
                }),
                body: generateContent_Body,
            },
        }),
    },
    "/ai/conversations/:conversationId/messages": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/ai/conversations/:conversationId/messages",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        messages: zod_1.z.array(zod_1.z.object({
                            id: zod_1.z.string(),
                            date: zod_1.z.string().optional(),
                            text: zod_1.z.string().optional(),
                            role: zod_1.z.enum(["user", "model"]).optional(),
                        })),
                    }),
                },
                querystring: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                params: zod_1.z.object({
                    conversationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/apikeys/": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/apikeys/",
            schema: {
                response: { [responseStatus]: ApiKey },
                body: createApiKey_Body,
            },
        }),
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/apikeys/",
            schema: {
                response: { [responseStatus]: zod_1.z.array(ApiKey) },
                querystring: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    accountId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/apikeys/:apiKeyId": {
        ["delete"]: (responseStatus = "200") => ({
            method: "DELETE",
            url: "/apikeys/:apiKeyId",
            schema: {
                response: { [responseStatus]: zod_1.z.void() },
                params: zod_1.z.object({
                    apiKeyId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/clients/": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/clients/",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ id: zod_1.z.string() }) },
                body: createClient_Body,
            },
        }),
    },
    "/index/account": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/index/account",
            schema: {
                response: { [responseStatus]: zod_1.z.void() },
                body: zod_1.z.object({ id: zod_1.z.string() }).passthrough(),
            },
        }),
    },
    "/index/accounts": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/index/accounts",
            schema: {
                response: { [responseStatus]: zod_1.z.void() },
            },
        }),
    },
    "/index/appointment": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/index/appointment",
            schema: {
                response: { [responseStatus]: zod_1.z.void() },
                body: indexAppointment_Body,
            },
        }),
    },
    "/index/contact": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/index/contact",
            schema: {
                response: { [responseStatus]: zod_1.z.void() },
                body: indexAppointment_Body,
            },
        }),
    },
    "/index/invoice": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/index/invoice",
            schema: {
                response: { [responseStatus]: zod_1.z.void() },
                body: indexAppointment_Body,
            },
        }),
    },
    "/index/label": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/index/label",
            schema: {
                response: { [responseStatus]: zod_1.z.void() },
                body: indexAppointment_Body,
            },
        }),
    },
    "/index/packageInstance": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/index/packageInstance",
            schema: {
                response: { [responseStatus]: zod_1.z.void() },
                body: indexAppointment_Body,
            },
        }),
    },
    "/integrations/:intId": {
        ["delete"]: (responseStatus = "200") => ({
            method: "DELETE",
            url: "/integrations/:intId",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    intId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/integrations/event-sync": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/integrations/event-sync",
            schema: {
                response: { [responseStatus]: GenericResponse },
                querystring: zod_1.z.object({
                    eventId: zod_1.z.string(),
                    integrationId: zod_1.z.string(),
                    accountId: zod_1.z.string(),
                    calendarId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/integrations/intuit/accountMap": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/integrations/intuit/accountMap",
            schema: {
                response: { [responseStatus]: GenericResponse },
                querystring: zod_1.z.object({
                    realmId: zod_1.z.string(),
                    organizationId: zod_1.z.string(),
                }),
                body: saveAccountMap_Body,
            },
        }),
    },
    "/integrations/intuit/auth": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/integrations/intuit/auth",
            schema: {
                response: { [responseStatus]: GenericResponse },
                querystring: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/integrations/intuit/config": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/integrations/intuit/config",
            schema: {
                response: { [responseStatus]: GenericResponse },
                querystring: zod_1.z.object({
                    realmId: zod_1.z.string(),
                    organizationId: zod_1.z.string(),
                }),
                body: updateRealmConfig_Body,
            },
        }),
    },
    "/integrations/intuit/connections": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/integrations/intuit/connections",
            schema: {
                response: { [responseStatus]: zod_1.z.array(zod_1.z.unknown()) },
                querystring: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/integrations/intuit/quickbooks/accounts": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/integrations/intuit/quickbooks/accounts",
            schema: {
                response: { [responseStatus]: zod_1.z.array(zod_1.z.unknown()) },
                querystring: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    realmId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/integrations/intuit/revoke": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/integrations/intuit/revoke",
            schema: {
                response: { [responseStatus]: GenericResponse },
                querystring: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    realmId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/integrations/intuit/sync": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/integrations/intuit/sync",
            schema: {
                response: { [responseStatus]: GenericResponse },
            },
        }),
    },
    "/integrations/intuit/sync/all": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/integrations/intuit/sync/all",
            schema: {
                response: { [responseStatus]: GenericResponse },
                querystring: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    realmId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/integrations/intuit/token-status": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/integrations/intuit/token-status",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({
                        isValid: zod_1.z.boolean(),
                        isExpired: zod_1.z.boolean(),
                        isRefreshTokenExpired: zod_1.z.boolean(),
                        message: zod_1.z.string(),
                    })
                        .partial()
                        .passthrough(),
                },
                querystring: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    realmId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/notifications/message": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/notifications/message",
            schema: {
                response: { [responseStatus]: GenericResponse },
                body: createNotificationMessage_Body,
            },
        }),
        ["put"]: (responseStatus = "200") => ({
            method: "PUT",
            url: "/notifications/message",
            schema: {
                response: { [responseStatus]: GenericResponse },
                body: updateNotificationMessage_Body,
            },
        }),
    },
    "/organizations": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ id: zod_1.z.string() }) },
            },
        }),
    },
    "/organizations/:organizationId/accounts": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/accounts",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({
                        list: zod_1.z.array(zod_1.z
                            .object({
                            id: zod_1.z.string(),
                            createdAt: zod_1.z.string().datetime({ offset: true }),
                            updatedAt: zod_1.z.string().datetime({ offset: true }),
                        })
                            .passthrough()
                            .and(zod_1.z.object({
                            firstName: zod_1.z.string(),
                            lastName: zod_1.z.string(),
                            email: zod_1.z.string().email(),
                            avatarURL: zod_1.z.string().nullish(),
                            lastRefreshTime: zod_1.z
                                .string()
                                .datetime({ offset: true })
                                .optional(),
                            accessType: zod_1.z.enum(["full", "elevated", "limited"]),
                            isOwner: zod_1.z.boolean(),
                            timeZone: zod_1.z.string().optional(),
                        }))),
                        integrations: Integrations,
                    })
                        .passthrough(),
                },
                querystring: zod_1.z.object({
                    skipIntegrations: skipIntegrations,
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/accounts-payable": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/accounts-payable",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        cursorId: zod_1.z.string().optional(),
                        data: zod_1.z.array(AccountsPayable),
                    }),
                },
                querystring: zod_1.z.object({
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    start: zod_1.z.string(),
                    end: zod_1.z.string(),
                    cursorId: zod_1.z.string().optional(),
                    memberId: zod_1.z.string().optional(),
                    invoicePaidStatus: zod_1.z.enum(["unpaid", "paid"]),
                    includeZeroInvoices: skipIntegrations,
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/accounts-payable/batch-mark": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/accounts-payable/batch-mark",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: markInvoicesAsPaidOrUnpaid_Body,
            },
        }),
    },
    "/organizations/:organizationId/accounts-payable/export-to-google-sheets": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/accounts-payable/export-to-google-sheets",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        spreadsheetId: zod_1.z.string(),
                        spreadsheetUrl: zod_1.z.string(),
                        fileName: zod_1.z.string(),
                        recordCount: zod_1.z.number().int(),
                    }),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: exportAccountsPayableToGoogleSheets_Body,
            },
        }),
    },
    "/organizations/:organizationId/accounts-payable/invoices/:invoiceId": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/accounts-payable/invoices/:invoiceId",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        data: zod_1.z.array(AccountsPayableTransaction),
                    }),
                },
                querystring: zod_1.z.object({
                    memberId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/accounts-payable/numbers": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/accounts-payable/numbers",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ totalInvoices: zod_1.z.number() }) },
                querystring: zod_1.z.object({
                    start: zod_1.z.string(),
                    end: zod_1.z.string(),
                    memberId: zod_1.z.string().optional(),
                    invoicePaidStatus: zod_1.z.enum(["unpaid", "paid"]),
                    includeZeroInvoices: skipIntegrations,
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/agents": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/agents",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({ agents: zod_1.z.array(AgentResponse) })
                        .partial(),
                },
                querystring: zod_1.z.object({
                    agentIds: zod_1.z.string().or(zod_1.z.array(zod_1.z.string())).optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/agents/:agentId": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/agents/:agentId",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({ agent: AgentResponse }).partial(),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    agentId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/agents/:agentId/activate": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/agents/:agentId/activate",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    agentId: zod_1.z.string(),
                }),
                body: activateAgent_Body,
            },
        }),
    },
    "/organizations/:organizationId/agents/:agentId/deactivate": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/agents/:agentId/deactivate",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    agentId: zod_1.z.string(),
                }),
                body: zod_1.z.object({ cancel: zod_1.z.boolean() }).partial().optional(),
            },
        }),
    },
    "/organizations/:organizationId/appointments/:appointmentId/delete": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/appointments/:appointmentId/delete",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    appointmentId: zod_1.z.string(),
                }),
                body: deleteAppointment_Body,
            },
        }),
    },
    "/organizations/:organizationId/appointments/:appointmentId/get-billing-transaction": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/appointments/:appointmentId/get-billing-transaction",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        id: zod_1.z.string(),
                        amount: zod_1.z.number(),
                        rate: zod_1.z.number(),
                        rateTitle: zod_1.z.string(),
                        status: zod_1.z.string(),
                        accountId: zod_1.z.string(),
                    }),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    appointmentId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/appointments/:appointmentId/get-invoice-related": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/appointments/:appointmentId/get-invoice-related",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        id: zod_1.z.string(),
                        status: InvoiceStatus,
                        isApproved: zod_1.z.boolean(),
                    }),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    appointmentId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/appointments/:appointmentId/get-notes": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/appointments/:appointmentId/get-notes",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        linkedNotes: zod_1.z.array(zod_1.z
                            .object({
                            id: zod_1.z.string(),
                            status: zod_1.z.string(),
                            title: zod_1.z.string(),
                            content: zod_1.z.string().optional(),
                            createdAt: zod_1.z.string().datetime({ offset: true }),
                            updatedAt: zod_1.z.string().datetime({ offset: true }).optional(),
                            clientId: zod_1.z.string().optional(),
                        })
                            .passthrough()),
                        unlinkedNotes: zod_1.z.array(zod_1.z
                            .object({
                            id: zod_1.z.string(),
                            status: zod_1.z.string(),
                            title: zod_1.z.string(),
                            content: zod_1.z.string().optional(),
                            createdAt: zod_1.z.string().datetime({ offset: true }),
                            updatedAt: zod_1.z.string().datetime({ offset: true }).optional(),
                            clientId: zod_1.z.string().optional(),
                        })
                            .passthrough()),
                    }),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    appointmentId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/billable-requests": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/billable-requests",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: submitBillableRequest_Body,
            },
        }),
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/billable-requests",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        cursorId: zod_1.z.string().optional(),
                        data: zod_1.z.array(BillableRequest),
                    }),
                },
                querystring: zod_1.z.object({
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    status: zod_1.z.enum(["submitted", "rejected", "approved"]).optional(),
                    cycleStart: zod_1.z.string().optional(),
                    cycleEnd: zod_1.z.string().optional(),
                    cursorId: zod_1.z.string().optional(),
                    accountId: zod_1.z.string().optional(),
                    clientId: zod_1.z.string().optional(),
                    billingRateId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/billable-requests/:billableRequestId": {
        ["delete"]: (responseStatus = "200") => ({
            method: "DELETE",
            url: "/organizations/:organizationId/billable-requests/:billableRequestId",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    billableRequestId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/billable-requests/:billableRequestId/status": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/billable-requests/:billableRequestId/status",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    billableRequestId: zod_1.z.string(),
                }),
                body: changeBillableRequestStatus_Body,
            },
        }),
    },
    "/organizations/:organizationId/billable-requests/batch-approve": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/billable-requests/batch-approve",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: postBatchApproveBillableRequests_Body,
            },
        }),
    },
    "/organizations/:organizationId/billable-requests/clients": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/billable-requests/clients",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        clients: zod_1.z.array(BillableRequestClient),
                    }),
                },
                querystring: zod_1.z.object({
                    accountId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/billable-requests/numbers": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/billable-requests/numbers",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        submitted: zod_1.z.number(),
                        rejected: zod_1.z.number(),
                        approved: zod_1.z.number(),
                    }),
                },
                querystring: zod_1.z.object({
                    cycleStart: zod_1.z.string().optional(),
                    cycleEnd: zod_1.z.string().optional(),
                    accountId: zod_1.z.string().optional(),
                    clientId: zod_1.z.string().optional(),
                    billingRateId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/billing-rates": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/billing-rates",
            schema: {
                response: { [responseStatus]: BillingRate },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: addBillingRate_Body,
            },
        }),
    },
    "/organizations/:organizationId/billing-rates/:billingRateId": {
        ["put"]: (responseStatus = "200") => ({
            method: "PUT",
            url: "/organizations/:organizationId/billing-rates/:billingRateId",
            schema: {
                response: { [responseStatus]: BillingRate },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    billingRateId: zod_1.z.string(),
                }),
                body: updateBillingRate_Body,
            },
        }),
    },
    "/organizations/:organizationId/billing-rates/:billingRateId/overwrite": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/billing-rates/:billingRateId/overwrite",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    billingRateId: zod_1.z.string(),
                }),
                body: overwriteBillingRate_Body,
            },
        }),
    },
    "/organizations/:organizationId/billing-rates/:billingRateId/status": {
        ["put"]: (responseStatus = "200") => ({
            method: "PUT",
            url: "/organizations/:organizationId/billing-rates/:billingRateId/status",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    billingRateId: zod_1.z.string(),
                }),
                body: updateBillingRateStatus_Body,
            },
        }),
    },
    "/organizations/:organizationId/billing-transactions/:billingTransactionId/move": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/billing-transactions/:billingTransactionId/move",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    billingTransactionId: zod_1.z.string(),
                }),
                body: zod_1.z.object({ targetInvoiceId: zod_1.z.string() }),
            },
        }),
    },
    "/organizations/:organizationId/change-owner": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/change-owner",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: zod_1.z.object({ accountId: zod_1.z.string() }),
            },
        }),
    },
    "/organizations/:organizationId/client-organization/:clientOrganizationId/archive": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/client-organization/:clientOrganizationId/archive",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientOrganizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/client-organization/:clientOrganizationId/members": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/client-organization/:clientOrganizationId/members",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        id: zod_1.z.string(),
                        name: zod_1.z.string(),
                        members: zod_1.z.array(zod_1.z
                            .object({
                            id: zod_1.z.string(),
                            firstName: zod_1.z.string().optional(),
                            lastName: zod_1.z.string().optional(),
                            email: zod_1.z.string(),
                            joined: zod_1.z.string().datetime({ offset: true }),
                            assigneeId: zod_1.z.string().optional(),
                            labels: zod_1.z.array(zod_1.z.string()).optional(),
                        })
                            .passthrough()),
                    }),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientOrganizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/client-organization/:clientOrganizationId/packageInstances": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/client-organization/:clientOrganizationId/packageInstances",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        packageInstances: zod_1.z.array(PackageInstanceCard),
                        internalForms: zod_1.z
                            .array(zod_1.z
                            .object({
                            id: zod_1.z.string(),
                            status: zod_1.z.string(),
                            title: zod_1.z.string().optional(),
                            submittedAt: zod_1.z
                                .string()
                                .datetime({ offset: true })
                                .optional(),
                            createdAt: zod_1.z
                                .string()
                                .datetime({ offset: true })
                                .optional(),
                            updatedAt: zod_1.z
                                .string()
                                .datetime({ offset: true })
                                .optional(),
                            description: zod_1.z.string().optional(),
                            templateId: zod_1.z.string(),
                        })
                            .passthrough())
                            .optional(),
                        forms: zod_1.z
                            .array(zod_1.z
                            .object({ id: zod_1.z.string(), status: zod_1.z.string() })
                            .partial()
                            .passthrough())
                            .optional(),
                        invoices: zod_1.z
                            .array(zod_1.z
                            .object({
                            id: zod_1.z.string(),
                            contactId: zod_1.z.string(),
                            status: zod_1.z.string(),
                            amount: zod_1.z.number(),
                            dueDate: zod_1.z.string().datetime({ offset: true }).optional(),
                            currency: zod_1.z.string(),
                            total: zod_1.z.number(),
                        })
                            .passthrough())
                            .optional(),
                        appointments: zod_1.z
                            .array(zod_1.z
                            .object({
                            id: zod_1.z.string(),
                            title: zod_1.z.string(),
                            start: zod_1.z.string().datetime({ offset: true }),
                            end: zod_1.z.string().datetime({ offset: true }),
                            status: zod_1.z.string(),
                            outcomeId: zod_1.z.string().optional(),
                            createdAt: zod_1.z.string(),
                            updatedAt: zod_1.z.string().optional(),
                        })
                            .passthrough())
                            .optional(),
                        notes: zod_1.z
                            .array(zod_1.z
                            .object({
                            id: zod_1.z.string(),
                            status: zod_1.z.string(),
                            title: zod_1.z.string(),
                            content: zod_1.z.string().optional(),
                            createdAt: zod_1.z.string().datetime({ offset: true }),
                            updatedAt: zod_1.z
                                .string()
                                .datetime({ offset: true })
                                .optional(),
                        })
                            .passthrough())
                            .optional(),
                    }),
                },
                querystring: zod_1.z.object({
                    includeArtifacts: zod_1.z.string().optional(),
                    memberId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientOrganizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/client-organization/:clientOrganizationId/update": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/client-organization/:clientOrganizationId/update",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientOrganizationId: zod_1.z.string(),
                }),
                body: updateClientOrganization_Body,
            },
        }),
    },
    "/organizations/:organizationId/client-organization/create": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/client-organization/create",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ id: zod_1.z.string() }) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: createClientOrganization_Body,
            },
        }),
    },
    "/organizations/:organizationId/client-statuses": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/client-statuses",
            schema: {
                response: { [responseStatus]: zod_1.z.array(ClientStatus) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/client-statuses/:clientStatusId": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/client-statuses/:clientStatusId",
            schema: {
                response: { [responseStatus]: ClientStatus },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientStatusId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/assign-package": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/assign-package",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ id: zod_1.z.string() }) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                }),
                body: assignPackage_Body,
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/book-package": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/book-package",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ id: zod_1.z.string() }) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                }),
                body: bookPackage_Body,
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/join-portal": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/join-portal",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/clients/:clientId/package-instances",
            schema: {
                response: { [responseStatus]: zod_1.z.array(PackageInstanceCard) },
                querystring: zod_1.z.object({
                    clientParentId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/activate": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/activate",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/cancel": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/cancel",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/end": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/end",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/end/preview": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/end/preview",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ endDate: zod_1.z.string() }) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/invoices": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/invoices",
            schema: {
                response: { [responseStatus]: zod_1.z.array(Invoice) },
                querystring: zod_1.z.object({
                    invoiceStatus: zod_1.z
                        .enum(["shared", "failed", "paid", "scheduled", "draft", "open"])
                        .optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/pause": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/pause",
            schema: {
                response: { [responseStatus]: GenericResponse },
                querystring: zod_1.z.object({
                    silent: skipIntegrations,
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/resume": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/resume",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
                body: zod_1.z.object({ cycleEndDate: zod_1.z.string() }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/reverse-cancel": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/reverse-cancel",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/update-package-instance-locked-status": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/update-package-instance-locked-status",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
                body: zod_1.z.object({ locked: zod_1.z.boolean() }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/update-payment-option": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/update-payment-option",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
                body: updatePackageInstancePaymentOption_Body,
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/update-setup-intent": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/update-setup-intent",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
                body: zod_1.z.object({ setupIntentClientSecret: zod_1.z.string() }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/update-tier": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/update-tier",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
                body: zod_1.z.object({ priceId: zod_1.z.string() }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/update-usage-pricing": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/:packageInstanceId/update-usage-pricing",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
                body: updateUsagePricing_Body,
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/package-instances/create-package-order": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/:clientId/package-instances/create-package-order",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ id: zod_1.z.string() }) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                }),
                body: createPackageOrder_Body,
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/payment-methods": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/clients/:clientId/payment-methods",
            schema: {
                response: { [responseStatus]: ClientPaymentMethods },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/clients/:clientId/update": {
        ["put"]: (responseStatus = "200") => ({
            method: "PUT",
            url: "/organizations/:organizationId/clients/:clientId/update",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ id: zod_1.z.string() }) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    clientId: zod_1.z.string(),
                }),
                body: updateClient_Body,
            },
        }),
    },
    "/organizations/:organizationId/clients/find": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/clients/find",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.union([
                        zod_1.z.object({ id: zod_1.z.string() }),
                        zod_1.z.object({ message: zod_1.z.string() }),
                    ]),
                },
                querystring: zod_1.z.object({
                    email: zod_1.z.string(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/clients/signup": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/clients/signup",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ id: zod_1.z.string() }) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: clientSignup_Body,
            },
        }),
    },
    "/organizations/:organizationId/custom-fields/:customFieldId": {
        ["delete"]: (responseStatus = "200") => ({
            method: "DELETE",
            url: "/organizations/:organizationId/custom-fields/:customFieldId",
            schema: {
                response: { [responseStatus]: zod_1.z.void() },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    customFieldId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/forms": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/forms",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        cursor: zod_1.z
                            .object({ formId: zod_1.z.string(), clientId: zod_1.z.string() })
                            .passthrough()
                            .optional(),
                        data: zod_1.z.array(Form),
                    }),
                },
                querystring: zod_1.z.object({
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    cursorFormId: zod_1.z.string().optional(),
                    cursorClientId: zod_1.z.string().optional(),
                    sortBy: zod_1.z.enum(["create", "update", "az"]).optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/import/clients/google-sheet": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/import/clients/google-sheet",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({
                        processed: zod_1.z.number().int(),
                        succeeded: zod_1.z.number().int(),
                        failed: zod_1.z.number().int(),
                        errors: zod_1.z.array(zod_1.z.string()),
                    })
                        .partial()
                        .passthrough(),
                },
                querystring: zod_1.z.object({
                    spreadsheetId: zod_1.z.string(),
                    sheetName: zod_1.z.string(),
                    userToken: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/import/members/google-sheet": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/import/members/google-sheet",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({
                        processed: zod_1.z.number().int(),
                        succeeded: zod_1.z.number().int(),
                        failed: zod_1.z.number().int(),
                        errors: zod_1.z.array(zod_1.z.string()),
                    })
                        .partial()
                        .passthrough(),
                },
                querystring: zod_1.z.object({
                    spreadsheetId: zod_1.z.string(),
                    sheetName: zod_1.z.string(),
                    userToken: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/integrations/google-sheets": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/integrations/google-sheets",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/internal-forms": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/internal-forms",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        cursorId: zod_1.z.string().optional(),
                        data: zod_1.z.array(InternalForm),
                    }),
                },
                querystring: zod_1.z.object({
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    cursorId: zod_1.z.string().optional(),
                    sortBy: zod_1.z.enum(["create", "update", "az"]).optional(),
                    accountId: zod_1.z.string(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/invoices": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/invoices",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        cursorId: zod_1.z.string().optional(),
                        data: zod_1.z.array(PaginatedInvoice),
                        total: zod_1.z.number().optional(),
                    }),
                },
                querystring: zod_1.z.object({
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    cursorId: zod_1.z.string().optional(),
                    invoicesStatusFilter: zod_1.z
                        .enum([
                        "all",
                        "succeeded",
                        "shared",
                        "failed",
                        "attention",
                        "refunded",
                    ])
                        .optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/invoices/:invoiceId",
            schema: {
                response: {
                    [responseStatus]: Invoice.and(zod_1.z.object({
                        refunds: zod_1.z.array(Refund).optional(),
                        creditNotes: zod_1.z.array(CreditNote).optional(),
                        isUBPInitialDeposit: zod_1.z.boolean(),
                        depositBalance: zod_1.z.number().optional(),
                        history: zod_1.z
                            .array(zod_1.z.object({
                            date: zod_1.z.string().datetime({ offset: true }),
                            title: zod_1.z.string(),
                            description: zod_1.z.string().optional(),
                            reason: zod_1.z.string().optional(),
                            type: zod_1.z.enum([
                                "failed_charge",
                                "refund",
                                "credit",
                                "completed",
                                "initiated",
                            ]),
                        }))
                            .optional(),
                    })),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/approve": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/invoices/:invoiceId/approve",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/cancel": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/invoices/:invoiceId/cancel",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/credit-note": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/invoices/:invoiceId/credit-note",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
                body: createCreditNote_Body,
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/link-package-instance": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/invoices/:invoiceId/link-package-instance",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
                body: zod_1.z.object({ packageInstanceId: zod_1.z.string() }),
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/mark-as-paid": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/invoices/:invoiceId/mark-as-paid",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/mark-as-shared": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/invoices/:invoiceId/mark-as-shared",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
                body: zod_1.z.object({ notify: zod_1.z.boolean() }).partial().optional(),
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/pay": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/invoices/:invoiceId/pay",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
                body: zod_1.z.object({
                    paymentMethodId: zod_1.z.string().regex(/^pm_[a-zA-Z0-9]+$/),
                }),
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/preview": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/invoices/:invoiceId/preview",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        id: zod_1.z.string(),
                        items: zod_1.z.array(zod_1.z.object({
                            transactionId: zod_1.z.string().optional(),
                            artifact: zod_1.z
                                .object({
                                id: zod_1.z.string(),
                                kind: BillingTransactionArtifactKind,
                            })
                                .optional(),
                            amount: zod_1.z.number(),
                            date: zod_1.z.string(),
                            quantity: zod_1.z.number(),
                            rate: zod_1.z.number(),
                            title: zod_1.z.string(),
                            isRollover: zod_1.z.boolean().optional(),
                        })),
                        totalAmount: zod_1.z.number(),
                        subTotal: zod_1.z.number(),
                        depositBalance: zod_1.z.number(),
                        overageAmount: zod_1.z.number().optional(),
                        updatedBalance: zod_1.z.number(),
                        currency: zod_1.z.string(),
                        isFromPastCycle: zod_1.z.boolean(),
                        cycle: zod_1.z.object({
                            start: zod_1.z.string().optional(),
                            end: zod_1.z.string().optional(),
                            cycle: zod_1.z.number().optional(),
                        }),
                        taxes: zod_1.z.array(zod_1.z.object({ label: zod_1.z.string(), amount: zod_1.z.number().optional() })),
                        isApproved: zod_1.z.boolean(),
                        needsAttention: zod_1.z.boolean(),
                        paymentNeedsAttention: zod_1.z.boolean().optional(),
                        status: InvoiceStatus,
                        invoiceMethod: InvoiceMethod.optional(),
                        dueDate: zod_1.z.string().optional(),
                        paidAt: zod_1.z.string().optional(),
                        sentAt: zod_1.z.string().optional(),
                        updatedAt: zod_1.z.string().optional(),
                        isLastInvoice: zod_1.z.boolean(),
                        isCurrentCycle: zod_1.z.boolean(),
                        packageInstance: zod_1.z.object({
                            id: zod_1.z.string(),
                            title: zod_1.z.string(),
                            icon: zod_1.z.string(),
                        }),
                        client: zod_1.z.object({
                            id: zod_1.z.string(),
                            firstName: zod_1.z.string().optional(),
                            lastName: zod_1.z.string().optional(),
                            email: zod_1.z.string(),
                            avatarURL: zod_1.z.string().optional(),
                        }),
                        parent: zod_1.z
                            .object({
                            id: zod_1.z.string(),
                            firstName: zod_1.z.string().optional(),
                            lastName: zod_1.z.string().optional(),
                            email: zod_1.z.string(),
                            avatarURL: zod_1.z.string().optional(),
                            clientType: zod_1.z.string(),
                        })
                            .optional(),
                        refunds: zod_1.z.array(Refund).optional(),
                        appointmentsInCycle: zod_1.z
                            .array(zod_1.z
                            .object({
                            id: zod_1.z.string(),
                            date: zod_1.z.string(),
                            title: zod_1.z.string(),
                            status: zod_1.z.enum([
                                "shared",
                                "confirmed",
                                "cancelled",
                                "declined",
                                "maybe",
                                "pending",
                                "deleted",
                                "tentative",
                                "accepted",
                                "needsAction",
                            ]),
                            member: zod_1.z
                                .object({
                                id: zod_1.z.string(),
                                firstName: zod_1.z.string(),
                                lastName: zod_1.z.string(),
                                avatarURL: zod_1.z.string(),
                            })
                                .partial()
                                .optional(),
                            outcome: Outcome.optional(),
                            hasPackage: zod_1.z.boolean(),
                            hidden: zod_1.z.boolean(),
                        })
                            .passthrough())
                            .optional(),
                    }),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/recompute": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/invoices/:invoiceId/recompute",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/refund": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/invoices/:invoiceId/refund",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
                body: refundInvoice_Body,
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/resolve-quickbooks-sync-failed": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/invoices/:invoiceId/resolve-quickbooks-sync-failed",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/sync": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/invoices/:invoiceId/sync",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/unapprove": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/invoices/:invoiceId/unapprove",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/invoices/:invoiceId/url": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/invoices/:invoiceId/url",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ url: zod_1.z.string() }) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    invoiceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/invoices/count": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/invoices/count",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        all: zod_1.z.number(),
                        succeeded: zod_1.z.number(),
                        shared: zod_1.z.number(),
                        failed: zod_1.z.number(),
                        attention: zod_1.z.number(),
                        refunded: zod_1.z.number(),
                    }),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/on-track": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/on-track",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        cursorId: zod_1.z.string().optional(),
                        data: zod_1.z.array(OnTrack),
                    }),
                },
                querystring: zod_1.z.object({
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    cursorId: zod_1.z.string().optional(),
                    memberId: zod_1.z.string().optional(),
                    packageTrackingStatus: zod_1.z
                        .enum(["on-track", "off-track", "at-risk"])
                        .optional(),
                    clientIds: zod_1.z.string().or(zod_1.z.array(zod_1.z.string())).optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/on-track/:packageInstanceId": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/on-track/:packageInstanceId",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
                body: zod_1.z
                    .object({ updateSmartActions: zod_1.z.boolean() })
                    .partial()
                    .optional(),
            },
        }),
    },
    "/organizations/:organizationId/on-track/count": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/on-track/count",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        onTrack: zod_1.z.number(),
                        atRisk: zod_1.z.number(),
                        offTrack: zod_1.z.number(),
                        onTrackByPackage: zod_1.z.number().optional(),
                        atRiskByPackage: zod_1.z.number().optional(),
                        offTrackByPackage: zod_1.z.number().optional(),
                    }),
                },
                querystring: zod_1.z.object({
                    packageId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId",
            schema: {
                response: { [responseStatus]: PackageInstanceCard },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId/can-schedule": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId/can-schedule",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        canSchedule: zod_1.z.boolean(),
                        reason: zod_1.z.string(),
                        code: zod_1.z.string(),
                    }),
                },
                querystring: zod_1.z.object({
                    start: zod_1.z.string(),
                    end: zod_1.z.string(),
                    schedulerId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId/complete": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId/complete",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId/current-invoice": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId/current-invoice",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        method: zod_1.z.string(),
                        cutOffDate: zod_1.z.string(),
                        autoChargeDate: zod_1.z.string().optional(),
                        invoice: zod_1.z
                            .object({
                            id: zod_1.z.string(),
                            status: zod_1.z.string(),
                            totalInCents: zod_1.z.number().optional(),
                            depositBalanceInCents: zod_1.z.number().optional(),
                            currency: zod_1.z.string(),
                            items: zod_1.z
                                .array(zod_1.z.object({
                                description: zod_1.z.string(),
                                quantity: zod_1.z.number(),
                                amountInCents: zod_1.z.number().optional(),
                            }))
                                .optional(),
                        })
                            .passthrough(),
                        nextInvoice: zod_1.z
                            .object({ cutOffDate: zod_1.z.string() })
                            .partial()
                            .passthrough(),
                    }),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId/delete": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId/delete",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId/invoices": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId/invoices",
            schema: {
                response: { [responseStatus]: zod_1.z.array(Invoice) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId/public": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId/public",
            schema: {
                response: { [responseStatus]: PackageInstancePublic },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId/should-block": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId/should-block",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({ shouldBlock: zod_1.z.boolean() }),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId/update-details": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId/update-details",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
                body: updatePackageInstanceDetails_Body,
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId/update-duration": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId/update-duration",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
                body: updatePackageInstanceDuration_Body,
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId/update-expiration-date": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId/update-expiration-date",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
                body: zod_1.z.object({
                    date: zod_1.z.string().datetime({ offset: true }).nullable(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId/update-next-cycle-start-date": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId/update-next-cycle-start-date",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
                body: zod_1.z.object({ date: zod_1.z.string().datetime({ offset: true }) }),
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId/update-start-date": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId/update-start-date",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
                body: zod_1.z.object({ date: zod_1.z.string().datetime({ offset: true }) }),
            },
        }),
    },
    "/organizations/:organizationId/package-instances/:packageInstanceId/update-subscription-price": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/package-instances/:packageInstanceId/update-subscription-price",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    packageInstanceId: zod_1.z.string(),
                }),
                body: zod_1.z.object({ priceId: zod_1.z.string() }),
            },
        }),
    },
    "/organizations/:organizationId/realm/:realmIdInPath/invoices-with-sync-quickbooks-issues": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/realm/:realmIdInPath/invoices-with-sync-quickbooks-issues",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.array(zod_1.z.object({
                        id: zod_1.z.string(),
                        total: zod_1.z.number(),
                        currency: zod_1.z.string(),
                        title: zod_1.z.string(),
                        clientId: zod_1.z.string(),
                        issues: zod_1.z.array(zod_1.z.object({
                            id: zod_1.z.string(),
                            message: zod_1.z.string(),
                            createdAt: zod_1.z.string().datetime({ offset: true }),
                        })),
                    })),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    realmIdInPath: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/reconciliation": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/reconciliation",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        cursor: zod_1.z
                            .object({ invoiceId: zod_1.z.string(), clientId: zod_1.z.string() })
                            .passthrough()
                            .optional(),
                        data: zod_1.z.array(Reconciliation),
                    }),
                },
                querystring: zod_1.z.object({
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    approved: skipIntegrations,
                    needsAttention: skipIntegrations,
                    clientLabelId: zod_1.z.string().optional(),
                    invoiceMethod: zod_1.z.enum(["auto", "manual"]).optional(),
                    cycleStart: zod_1.z.string().optional(),
                    cycleEnd: zod_1.z.string().optional(),
                    cursorInvoiceId: zod_1.z.string().optional(),
                    cursorClientId: zod_1.z.string().optional(),
                    invoiceStatus: zod_1.z
                        .enum(["shared", "failed", "paid", "scheduled", "draft", "open"])
                        .optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/reconciliation/attention-needed": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/reconciliation/attention-needed",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.array(zod_1.z.object({ invoiceId: zod_1.z.string(), clientId: zod_1.z.string() })),
                },
                querystring: zod_1.z.object({
                    cycleStart: zod_1.z.string().optional(),
                    cycleEnd: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/reconciliation/batch-approve": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/reconciliation/batch-approve",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: postBatchApproveInvoices_Body,
            },
        }),
    },
    "/organizations/:organizationId/reconciliation/cycles": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/reconciliation/cycles",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.array(zod_1.z.object({ label: zod_1.z.string(), start: zod_1.z.string(), end: zod_1.z.string() })),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/reconciliation/numbers": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/reconciliation/numbers",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        totalApproved: zod_1.z.number(),
                        totalInReview: zod_1.z.number(),
                    }),
                },
                querystring: zod_1.z.object({
                    cycleStart: zod_1.z.string().optional(),
                    cycleEnd: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/reporting/counts": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/reporting/counts",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({ data: zod_1.z.object({ total: zod_1.z.number() }) }),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: generateTimeseriesCounts_Body,
            },
        }),
    },
    "/organizations/:organizationId/reporting/timeseries": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/reporting/timeseries",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        data: zod_1.z.array(zod_1.z.object({ date: zod_1.z.string() }).passthrough()),
                        series: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), name: zod_1.z.string() })),
                    }),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: DashboardConfiguration,
            },
        }),
    },
    "/organizations/:organizationId/schedulers": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/schedulers",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ id: zod_1.z.string() }) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: Scheduler,
            },
        }),
    },
    "/organizations/:organizationId/schedulers/:organizationSchedulerId": {
        ["put"]: (responseStatus = "200") => ({
            method: "PUT",
            url: "/organizations/:organizationId/schedulers/:organizationSchedulerId",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ id: zod_1.z.string() }) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    organizationSchedulerId: zod_1.z.string(),
                }),
                body: Scheduler,
            },
        }),
    },
    "/organizations/:organizationId/session-billing": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/session-billing",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: setupSessionBilling_Body,
            },
        }),
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/session-billing",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        organizationId: zod_1.z.string(),
                        sessionBillingSettings: SessionBillingSettings,
                        billingRates: zod_1.z.array(BillingRate),
                    }),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/session-billing/accepted-outcomes": {
        ["put"]: (responseStatus = "200") => ({
            method: "PUT",
            url: "/organizations/:organizationId/session-billing/accepted-outcomes",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: updateSessionBillingAcceptedOutcomes_Body,
            },
        }),
    },
    "/organizations/:organizationId/session-billing/billable-reviewers": {
        ["put"]: (responseStatus = "200") => ({
            method: "PUT",
            url: "/organizations/:organizationId/session-billing/billable-reviewers",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: updateBillableReviewers_Body,
            },
        }),
    },
    "/organizations/:organizationId/session-billing/cycles": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/session-billing/cycles",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.array(zod_1.z.object({ label: zod_1.z.string(), start: zod_1.z.string(), end: zod_1.z.string() })),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/session-billing/cycles/summary": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/session-billing/cycles/summary",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        amount: zod_1.z.number(),
                        totalSessions: zod_1.z.number(),
                        paid: zod_1.z.boolean(),
                        sessionsGroupedByRate: zod_1.z.array(zod_1.z.object({
                            quantity: zod_1.z.number(),
                            rate: zod_1.z.number(),
                            title: zod_1.z.string(),
                            amount: zod_1.z.number(),
                            isRateCurrentValue: zod_1.z.boolean().optional(),
                            transactions: zod_1.z.array(BillingTransaction),
                        })),
                        sessionsGroupedByClient: zod_1.z.array(ClientSessions),
                    }),
                },
                querystring: zod_1.z.object({
                    start: zod_1.z.string(),
                    end: zod_1.z.string(),
                    memberId: zod_1.z.string(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/session-billing/cycles/total-over-time": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/session-billing/cycles/total-over-time",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        amount: zod_1.z.number(),
                        totalBillingCycles: zod_1.z.number(),
                        billingCycles: zod_1.z.array(zod_1.z.object({
                            quantity: zod_1.z.number(),
                            amount: zod_1.z.number(),
                            paid: zod_1.z.boolean(),
                            start: zod_1.z.string(),
                            end: zod_1.z.string(),
                            label: zod_1.z.string(),
                        })),
                        sessionsGroupedByClient: zod_1.z.array(ClientSessions),
                    }),
                },
                querystring: zod_1.z.object({
                    memberId: zod_1.z.string(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/session-billing/mark-transactions": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/session-billing/mark-transactions",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
                body: markBillingTransactionsAsPaidOrUnpaid_Body,
            },
        }),
    },
    "/organizations/:organizationId/stripe/recurring-products": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/stripe/recurring-products",
            schema: {
                response: { [responseStatus]: zod_1.z.array(StripeProductItem) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/threads": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/threads",
            schema: {
                response: {
                    [responseStatus]: zod_1.z.object({
                        data: zod_1.z.array(zod_1.z.object({
                            id: zod_1.z.string(),
                            subject: zod_1.z.string(),
                            count: zod_1.z.number(),
                            date: zod_1.z.string().datetime({ offset: true }),
                            status: zod_1.z.string(),
                        })),
                    }),
                },
                querystring: zod_1.z.object({
                    contactId: zod_1.z.string(),
                    limit: zod_1.z
                        .string()
                        .transform((v) => parseInt(v))
                        .optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/todays-view/active-clients": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/todays-view/active-clients",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ data: TodaysView }) },
                querystring: zod_1.z.object({
                    labelId: zod_1.z.string().optional(),
                    memberId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/todays-view/active-packages": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/todays-view/active-packages",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ data: TodaysView }) },
                querystring: zod_1.z.object({
                    packageId: zod_1.z.string().optional(),
                    memberId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/todays-view/sessions-by-outcome": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/todays-view/sessions-by-outcome",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ data: TodaysView }) },
                querystring: zod_1.z.object({
                    memberId: zod_1.z.string().optional(),
                    start: zod_1.z.string().optional(),
                    end: zod_1.z.string().optional(),
                    outcomeId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/todays-view/sessions-by-scheduler": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/todays-view/sessions-by-scheduler",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ data: TodaysView }) },
                querystring: zod_1.z.object({
                    memberId: zod_1.z.string().optional(),
                    start: zod_1.z.string().optional(),
                    end: zod_1.z.string().optional(),
                    schedulerId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/workflow/:workflowId/execution/:executionId": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/workflow/:workflowId/execution/:executionId",
            schema: {
                response: {
                    [responseStatus]: WorkflowExecution.and(zod_1.z
                        .object({ steps: zod_1.z.array(WorkflowStep) })
                        .partial()
                        .passthrough()),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    workflowId: zod_1.z.string(),
                    executionId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/workflow/:workflowId/execution/:executionId/event": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/workflow/:workflowId/execution/:executionId/event",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    workflowId: zod_1.z.string(),
                    executionId: zod_1.z.string(),
                }),
                body: signalWorkflowEvent_Body,
            },
        }),
    },
    "/organizations/:organizationId/workflow/:workflowName/executions": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/workflow/:workflowName/executions",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({
                        counts: WorkflowExecutionCounts,
                        executions: zod_1.z.array(WorkflowExecution),
                        nextPageToken: zod_1.z.string(),
                    })
                        .partial(),
                },
                querystring: zod_1.z.object({
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    cursorId: zod_1.z.string().optional(),
                    keywords: zod_1.z.string().or(zod_1.z.array(zod_1.z.string())).optional(),
                    workflowExecutionStatuses: zod_1.z
                        .string()
                        .or(zod_1.z.array(zod_1.z.string()))
                        .optional(),
                    workflowParentFlag: skipIntegrations,
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    workflowName: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/workflow/:workflowName/start": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/workflow/:workflowName/start",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({ workflowId: zod_1.z.string(), executionId: zod_1.z.string() })
                        .passthrough(),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    workflowName: zod_1.z.string(),
                }),
                body: zod_1.z
                    .object({ payload: zod_1.z.object({}).partial().passthrough() })
                    .partial()
                    .passthrough(),
            },
        }),
    },
    "/organizations/:organizationId/workflow/executions": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/workflow/executions",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({
                        counts: WorkflowExecutionCounts,
                        executions: zod_1.z.array(WorkflowExecution),
                        nextPageToken: zod_1.z.string(),
                    })
                        .partial(),
                },
                querystring: zod_1.z.object({
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    cursorId: zod_1.z.string().optional(),
                    keywords: zod_1.z.string().or(zod_1.z.array(zod_1.z.string())).optional(),
                    workflowExecutionStatuses: zod_1.z
                        .string()
                        .or(zod_1.z.array(zod_1.z.string()))
                        .optional(),
                    workflowParentFlag: skipIntegrations,
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/search": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/search",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({
                        result: zod_1.z
                            .object({
                            hits: zod_1.z.array(zod_1.z
                                .object({
                                document: zod_1.z.object({}).partial().passthrough(),
                                highlights: zod_1.z.array(zod_1.z
                                    .object({
                                    field: zod_1.z.string(),
                                    matches: zod_1.z.array(zod_1.z.string()),
                                })
                                    .passthrough()),
                            })
                                .passthrough()),
                            total: zod_1.z.number(),
                        })
                            .passthrough(),
                    })
                        .passthrough(),
                },
                body: search_Body,
            },
        }),
    },
    "/signup": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/signup",
            schema: {
                response: { [responseStatus]: SignupResponse },
                body: SignupRequest,
            },
        }),
    },
    "/users/": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/users/",
            schema: {
                response: {
                    [responseStatus]: PaginatedResponse.and(zod_1.z.object({ data: Organizations })),
                },
                querystring: zod_1.z.object({
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    before: zod_1.z.string().optional(),
                    after: zod_1.z.string().optional(),
                }),
            },
        }),
    },
    "/workflows": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/workflows",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({
                        workflowConfigurations: zod_1.z.array(WorkflowConfiguration),
                        nextPageToken: zod_1.z.string(),
                    })
                        .partial(),
                },
                querystring: zod_1.z.object({
                    limit: zod_1.z.string().transform((v) => parseInt(v)),
                    cursorId: zod_1.z.string().optional(),
                    keywords: zod_1.z.string().or(zod_1.z.array(zod_1.z.string())).optional(),
                }),
            },
        }),
    },
};
exports.groupSchedulerSchemas = {
    "/organizations/:organizationId/group-schedulers/:groupSchedulerId/attendees": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/group-schedulers/:groupSchedulerId/attendees",
            schema: {
                response: { [responseStatus]: zod_1.z.array(SlotAttendance) },
                querystring: zod_1.z.object({
                    timeslotId: zod_1.z.string().optional(),
                    timeslotRecurringDate: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    groupSchedulerId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/group-schedulers/:groupSchedulerId/join-curriculum": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/group-schedulers/:groupSchedulerId/join-curriculum",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    groupSchedulerId: zod_1.z.string(),
                }),
                body: joinCurriculumScheduler_Body,
            },
        }),
    },
    "/organizations/:organizationId/group-schedulers/:groupSchedulerId/leave-curriculum": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/group-schedulers/:groupSchedulerId/leave-curriculum",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    groupSchedulerId: zod_1.z.string(),
                }),
                body: leaveCurriculumScheduler_Body,
            },
        }),
    },
    "/organizations/:organizationId/group-schedulers/:groupSchedulerId/progress": {
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/group-schedulers/:groupSchedulerId/progress",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({
                        totalSessions: zod_1.z.number().int(),
                        completedSessions: zod_1.z.number().int(),
                        remainingSessions: zod_1.z.number().int(),
                        sessions: zod_1.z.array(GroupSchedulerTimeslot.and(zod_1.z
                            .object({
                            appointment: zod_1.z
                                .object({ outcome: Outcome, id: zod_1.z.string() })
                                .partial()
                                .passthrough(),
                        })
                            .partial()
                            .passthrough())),
                        isFull: zod_1.z.boolean(),
                        nextSession: GroupSchedulerTimeslot.optional(),
                        startDate: zod_1.z.string().optional(),
                        endDate: zod_1.z.string().optional(),
                        attendance: SlotAttendance.optional(),
                        scheduler: zod_1.z
                            .object({
                            id: zod_1.z.string(),
                            title: zod_1.z.string(),
                            description: zod_1.z.string(),
                            maxParticipants: zod_1.z.number().int().nullish(),
                            icon: zod_1.z.string(),
                        })
                            .passthrough(),
                    })
                        .passthrough(),
                },
                querystring: zod_1.z.object({
                    clientId: zod_1.z.string().optional(),
                    packageInstanceId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    groupSchedulerId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/group-schedulers/:groupSchedulerId/timeslots": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/group-schedulers/:groupSchedulerId/timeslots",
            schema: {
                response: { [responseStatus]: zod_1.z.object({ id: zod_1.z.string() }) },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    groupSchedulerId: zod_1.z.string(),
                }),
                body: CreateGroupSchedulerTimeslot,
            },
        }),
        ["get"]: (responseStatus = "200") => ({
            method: "GET",
            url: "/organizations/:organizationId/group-schedulers/:groupSchedulerId/timeslots",
            schema: {
                response: { [responseStatus]: zod_1.z.array(GroupSchedulerTimeslot) },
                querystring: zod_1.z.object({
                    startTime: zod_1.z.string().datetime({ offset: true }),
                    endTime: zod_1.z.string().datetime({ offset: true }),
                    clientId: zod_1.z.string().optional(),
                }),
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    groupSchedulerId: zod_1.z.string(),
                }),
            },
        }),
    },
    "/organizations/:organizationId/group-schedulers/:groupSchedulerId/timeslots/:timeslotId/book": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/group-schedulers/:groupSchedulerId/timeslots/:timeslotId/book",
            schema: {
                response: {
                    [responseStatus]: zod_1.z
                        .object({ appointmentId: zod_1.z.string() })
                        .partial()
                        .passthrough(),
                },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    groupSchedulerId: zod_1.z.string(),
                    timeslotId: zod_1.z.string(),
                }),
                body: bookGroupSchedulerTimeslot_Body,
            },
        }),
    },
    "/organizations/:organizationId/group-schedulers/:groupSchedulerId/timeslots/:timeslotId/cancel": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/group-schedulers/:groupSchedulerId/timeslots/:timeslotId/cancel",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    groupSchedulerId: zod_1.z.string(),
                    timeslotId: zod_1.z.string(),
                }),
                body: cancelGroupSchedulerTimeslot_Body,
            },
        }),
    },
    "/organizations/:organizationId/group-schedulers/:groupSchedulerId/timeslots/:timeslotId/configure": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/group-schedulers/:groupSchedulerId/timeslots/:timeslotId/configure",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    groupSchedulerId: zod_1.z.string(),
                    timeslotId: zod_1.z.string(),
                }),
                body: ConfigureGroupSchedulerTimeslot,
            },
        }),
    },
    "/organizations/:organizationId/group-schedulers/:groupSchedulerId/timeslots/:timeslotId/delete": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/group-schedulers/:groupSchedulerId/timeslots/:timeslotId/delete",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    groupSchedulerId: zod_1.z.string(),
                    timeslotId: zod_1.z.string(),
                }),
                body: deleteGroupSchedulerTimeslot_Body,
            },
        }),
    },
    "/organizations/:organizationId/group-schedulers/:groupSchedulerId/timeslots/:timeslotId/delete-attendance": {
        ["post"]: (responseStatus = "200") => ({
            method: "POST",
            url: "/organizations/:organizationId/group-schedulers/:groupSchedulerId/timeslots/:timeslotId/delete-attendance",
            schema: {
                response: { [responseStatus]: GenericResponse },
                params: zod_1.z.object({
                    organizationId: zod_1.z.string(),
                    groupSchedulerId: zod_1.z.string(),
                    timeslotId: zod_1.z.string(),
                }),
                body: deleteGroupSchedulerAttendance_Body,
            },
        }),
    },
};
//# sourceMappingURL=zod-schemas.js.map